<div class="page-designer-toolbar" [style.width.px]="panelCollapsed ? 0 : panelWidth">
  <div class="page-designer-toolbar-container" cdkDropListGroup>
    <div class='p-0 bg-white h-100 container-container'>
      <div class='w-100'>
        <div class="share-presets-row bg-light">
          <span class="share-presets-label">Presets</span>
          <div class="share-presets-select">
            <app-creatable-select
              [hideLabel]="true"
              [isCreatable]="false"
              [selectedValue]="selectedSharePresetId"
              [placeholder]="'Select preset'"
              [selectOptions]="sharePresetOptions"
              [labelKey]="'name'"
              [descriptionKey]="'description'"
              [optionActionsTemplate]="sharePresetOptionActions"
              [onlyBottomBorder]="false"
              [clearable]="false"
              [emitSelectedOptionClick]="true"
              [containerClass]="'share-preset-dropdown'"
              (optionSelected)="onSharePresetSelected($event, applySharePresetModal)"
              (selectedOptionClicked)="onSelectedSharePresetClicked($event, applySharePresetModal)">
            </app-creatable-select>
            <ng-template #sharePresetOptionActions let-item="item">
              @if (item.can_delete) {
              <button
                      type="button"
                      class="share-preset-delete-option"
                      title="Delete preset"
                      (click)="deleteSharePreset($event, item)">
                &times;
              </button>
              }
            </ng-template>
          </div>
          <button type="button"
                  class="btn btn-primary btn-sm share-presets-save-btn"
                  (click)="openSharePresetSaveModal(saveSharePresetModal)">
            Save
          </button>
        </div>
        <div class='bg-light sidebar-accordion social-networks-icons-tab'
             [style.height.px]="socialNetworksIconsHeight">
          <div class="d-flex flex-wrap">
            <div class='d-flex justify-content-center'>
              <div
                class="box-swap"
                appDragBox
                [zIndexMoving]="'9999'"
                (movingOffset)="onMovingSocialNetworkItems($event, positions[0])"
                [position]="{ x: positions[0].x, y: positions[0].y }"
              >
                <button (click)="changeSocialMediaPreview('linkedin')"
                        [class]="{active: currentSocialMediaPreviewing === 'linkedin' && this.socialPlatformVisibility['linkedin'],
                    disable: !this.socialPlatformVisibility['linkedin'] }"
                        class='btn mx-auto'>
                  <i class='fab fa-linkedin' title="Linkedin"></i>
                </button>
              </div>
            </div>
            <div class='d-flex justify-content-center'>
              <div
                class="box-swap"
                appDragBox
                [zIndexMoving]="'9999'"
                (movingOffset)="onMovingSocialNetworkItems($event, positions[1])"
                [position]="{ x: positions[1].x, y: positions[1].y }"
              >
                <button (click)="changeSocialMediaPreview('whatsapp')"
                        [class]="{active: currentSocialMediaPreviewing === 'whatsapp' && this.socialPlatformVisibility['whatsapp'],
                    disable: !this.socialPlatformVisibility['whatsapp'] }"
                        class='btn mx-auto'>
                  <i class='fab fa-whatsapp' title="Whatsapp"></i>
                </button>
              </div>
            </div>
            <div class='d-flex justify-content-center'>
              <div
                class="box-swap"
                appDragBox
                [zIndexMoving]="'9999'"
                (movingOffset)="onMovingSocialNetworkItems($event, positions[2])"
                [position]="{ x: positions[2].x, y: positions[2].y }"
              >
                <button (click)="changeSocialMediaPreview('email')"
                        [class]="{active: currentSocialMediaPreviewing === 'email' && this.socialPlatformVisibility['email'],
                      disable: !this.socialPlatformVisibility['email'] }"
                        class='btn mx-auto'>
                  <i class='fa fa-envelope' title="Email"></i>
                </button>
              </div>
            </div>
            <div class='d-flex justify-content-center'>
              <div
                class="box-swap"
                appDragBox
                [zIndexMoving]="'9999'"
                (movingOffset)="onMovingSocialNetworkItems($event, positions[3])"
                [position]="{ x: positions[3].x, y: positions[3].y }"
              >
              <button (click)="changeSocialMediaPreview('facebook')"
                      [class]="{active: currentSocialMediaPreviewing === 'facebook' && this.socialPlatformVisibility['facebook'],
                    disable: !this.socialPlatformVisibility['facebook'] }"
                      class='btn mx-auto'>
                <i class='fab fa-facebook' title="Facebook"></i>
              </button>
              </div>
            </div>
            <div class='d-flex justify-content-center'>
              <div
                class="box-swap"
                appDragBox
                [zIndexMoving]="'9999'"
                (movingOffset)="onMovingSocialNetworkItems($event, positions[4])"
                [position]="{ x: positions[4].x, y: positions[4].y }"
              >
                <button (click)="changeSocialMediaPreview('instagram')"
                        [class]="{active: currentSocialMediaPreviewing === 'instagram' && this.socialPlatformVisibility['instagram'],
                    disable: !this.socialPlatformVisibility['instagram'] }"
                        class='btn mx-auto'>
                  <i class='fab fa-instagram' title="Instagram"></i>
                </button>
              </div>
            </div>
            <div class='d-flex justify-content-center'>
              <div
                class="box-swap"
                appDragBox
                [zIndexMoving]="'9999'"
                (movingOffset)="onMovingSocialNetworkItems($event, positions[5])"
                [position]="{ x: positions[5].x, y: positions[5].y }"
              >
                <button (click)="changeSocialMediaPreview('sms')"
                  [class]="{
                    active: currentSocialMediaPreviewing === 'sms' && this.socialPlatformVisibility['sms'],
                    disable: !this.socialPlatformVisibility['sms'],
                    overLimit: getCharacterCount('sms') > getMaxLength('sms')
                  }"
                class='btn mx-auto'>
                  <i class="fa fa-comments" title="SMS"></i>
                </button>
              </div>
            </div>
            <div class='d-flex justify-content-center'>
              <div
                class="box-swap"
                appDragBox
                [zIndexMoving]="'9999'"
                (movingOffset)="onMovingSocialNetworkItems($event, positions[6])"
                [position]="{ x: positions[6].x, y: positions[6].y }"
              >
                <button (click)="changeSocialMediaPreview('facebook_messenger')"
                        [class.active]="currentSocialMediaPreviewing === 'facebook_messenger' && this.socialPlatformVisibility['facebook_messenger']"
                        class='btn mx-auto social-share-btn-icon'>
                  <svg [class.svg_disable]="!this.socialPlatformVisibility['facebook_messenger']" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <title>Facebook messenger</title>
                    <path
                      d="M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94 8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57 504 110.34 396.59 8 256.55 8zm149.24 185.13l-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z"/>
                  </svg>
                </button>
              </div>
            </div>
            <div class='d-flex justify-content-center'>
              <div
                class="box-swap"
                appDragBox
                [zIndexMoving]="'9999'"
                (movingOffset)="onMovingSocialNetworkItems($event, positions[7])"
                [position]="{ x: positions[7].x, y: positions[7].y }"
              >
                <button (click)="changeSocialMediaPreview('twitter')"
                  [class]="{
                    active: currentSocialMediaPreviewing === 'twitter' && this.socialPlatformVisibility['twitter'],
                    disable: !this.socialPlatformVisibility['twitter'],
                    overLimit: getCharacterCount('twitter') > getMaxLength('twitter')
                  }"
                  class='btn mx-auto'>
                    <i class='fa-brands fa-x-twitter' title="Twitter"></i>
                </button>
              </div>
            </div>
            <div class='d-flex justify-content-center'>
              <div
                class="box-swap"
                appDragBox
                [zIndexMoving]="'9999'"
                (movingOffset)="onMovingSocialNetworkItems($event, positions[8])"
                [position]="{ x: positions[8].x, y: positions[8].y }"
              >
                <button (click)="changeSocialMediaPreview('microsoft_teams')"
                        [class.active]="currentSocialMediaPreviewing === 'microsoft_teams' && this.socialPlatformVisibility['microsoft_teams']"
                        class='btn mx-auto social-share-btn-icon'>
                  <svg  [class.svg_disable]="!this.socialPlatformVisibility['microsoft_teams']" class="team-icon" version="1.1" id="Livello_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 2228.83 2073.33" xml:space="preserve">
                  <title>Microsoft teams</title>
                    <path class="st0" d="M1554.64,777.5h575.71c54.39,0,98.48,44.09,98.48,98.48l0,0v524.4c0,199.9-162.05,361.95-361.95,361.95l0,0	h-1.71c-199.9,0.03-361.97-162-362-361.9c0-0.02,0-0.03,0-0.05V828.97C1503.17,800.54,1526.21,777.5,1554.64,777.5L1554.64,777.5z"/>
                    <circle class="st0" cx="1943.75" cy="440.58" r="233.25"/>
                    <circle class="st1" cx="1218.08" cy="336.92" r="336.92"/>
                    <path class="st1" d="M1667.32,777.5H717.01c-53.74,1.33-96.26,45.93-95.01,99.68v598.1c-7.51,322.52,247.66,590.16,570.17,598.05	c322.51-7.89,577.67-275.53,570.17-598.05v-598.1C1763.58,823.43,1721.07,778.83,1667.32,777.5z"/>
                    <path class="st2" d="M1244,777.5v838.15c-0.26,38.44-23.55,72.96-59.09,87.6c-11.32,4.79-23.48,7.25-35.77,7.26H667.61	c-6.74-17.1-12.96-34.21-18.14-51.83c-18.14-59.48-27.4-121.31-27.47-183.49V877.02c-1.25-53.66,41.2-98.19,94.85-99.52H1244z"/>
                    <path class="st3" d="M1192.17,777.5v889.98c0,12.29-2.47,24.45-7.26,35.77c-14.63,35.54-49.16,58.83-87.6,59.09H691.97	c-8.81-17.1-17.1-34.21-24.36-51.83s-12.96-34.21-18.14-51.83c-18.14-59.48-27.4-121.31-27.47-183.49V877.02	c-1.25-53.66,41.2-98.19,94.85-99.52H1192.17z"/>
                    <path class="st3" d="M1192.17,777.5v786.31c-0.4,52.22-42.63,94.46-94.85,94.85H649.47c-18.14-59.48-27.4-121.31-27.47-183.49	V877.02c-1.25-53.66,41.2-98.19,94.85-99.52H1192.17z"/>
                    <path class="st3" d="M1140.33,777.5v786.31c-0.4,52.22-42.63,94.46-94.85,94.85H649.47c-18.14-59.48-27.4-121.31-27.47-183.49	V877.02c-1.25-53.66,41.2-98.19,94.85-99.52H1140.33z"/>
                    <path class="st2" d="M1244,509.52V672.8c-8.81,0.52-17.1,1.04-25.92,1.04s-17.1-0.52-25.92-1.04c-17.5-1.16-34.85-3.94-51.83-8.29	c-104.96-24.86-191.68-98.47-233.25-198c-7.15-16.71-12.71-34.07-16.59-51.83h258.65C1201.45,414.87,1243.8,457.22,1244,509.52z"/>
                    <path class="st3" d="M1192.17,561.35V672.8c-17.5-1.16-34.85-3.94-51.83-8.29c-104.96-24.86-191.68-98.47-233.25-198h190.23	C1149.62,466.7,1191.97,509.05,1192.17,561.35z"/>
                    <path class="st3" d="M1192.17,561.35V672.8c-17.5-1.16-34.85-3.94-51.83-8.29c-104.96-24.86-191.68-98.47-233.25-198h190.23	C1149.62,466.7,1191.97,509.05,1192.17,561.35z"/>
                    <path class="st3" d="M1140.33,561.35V664.5c-104.96-24.86-191.68-98.47-233.25-198h138.4	C1097.78,466.7,1140.13,509.05,1140.33,561.35z"/>
                    <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="198.0988" y1="-1123.0724" x2="942.2333" y2="165.7381" gradientTransform="matrix(1 0 0 1 0 1515.3333)">
                    <stop offset="0" style="stop-color:#5A62C3"/>
                      <stop offset="0.5" style="stop-color:#4D55BD"/>
                      <stop offset="1" style="stop-color:#3940AB"/>
                  </linearGradient>
                    <path class="st4" d="M95.01,466.5h950.31c52.47,0,95.01,42.54,95.01,95.01v950.31c0,52.47-42.54,95.01-95.01,95.01H95.01	c-52.47,0-95.01-42.54-95.01-95.01V561.51C0,509.04,42.54,466.5,95.01,466.5z"/>
                    <path class="st5" d="M820.21,828.19H630.24v517.3H509.21v-517.3H320.12V727.84h500.09V828.19z"/>
                </svg>
                </button>
              </div>
            </div>
            <div class='d-flex justify-content-center'>
              <div
                class="box-swap"
                appDragBox
                [zIndexMoving]="'9999'"
                (movingOffset)="onMovingSocialNetworkItems($event, positions[9])"
                [position]="{ x: positions[9].x, y: positions[9].y }"
              >
                <button (click)="changeSocialMediaPreview('slack')"
                        [class]="{active: currentSocialMediaPreviewing === 'slack' && this.socialPlatformVisibility['slack'],
                    disable: !this.socialPlatformVisibility['slack'] }"
                        class='btn mx-auto'>
                  <i class='fab fa-slack' title="Slack"></i>
                </button>
              </div>
            </div>
            <div class='d-flex justify-content-center'>
              <div
                class="box-swap"
                appDragBox
                [zIndexMoving]="'9999'"
                (movingOffset)="onMovingSocialNetworkItems($event, positions[10])"
                [position]="{ x: positions[10].x, y: positions[10].y }"
              >
                <button (click)="changeSocialMediaPreview('bluesky')"
                        [class]="{active: currentSocialMediaPreviewing === 'bluesky' && this.socialPlatformVisibility['bluesky'],
                        disable: !this.socialPlatformVisibility['bluesky'] }"
                        class='btn mx-auto social-share-btn-icon'>
                  <svg class="bluesky-icon" [class.svg_disable]="!this.socialPlatformVisibility['bluesky']" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <title>Bluesky</title>
                    <path d="M111.8 62.2C170.2 105.9 233 194.7 256 242.4c23-47.6 85.8-136.4 144.2-180.2c42.1-31.6 110.3-56 110.3 21.8c0 15.5-8.9 130.5-14.1 149.2C478.2 298 412 314.6 353.1 304.5c102.9 17.5 129.1 75.5 72.5 133.5c-107.4 110.2-154.3-27.6-166.3-62.9l0 0c-1.7-4.9-2.6-7.8-3.3-7.8s-1.6 3-3.3 7.8l0 0c-12 35.3-59 173.1-166.3 62.9c-56.5-58-30.4-116 72.5-133.5C100 314.6 33.8 298 15.7 233.1C10.4 214.4 1.5 99.4 1.5 83.9c0-77.8 68.2-53.4 110.3-21.8z"/>
                  </svg>
                </button>
              </div>
            </div>
            <div class='d-flex justify-content-center'>
              <div
                class="box-swap"
                appDragBox
                [zIndexMoving]="'9999'"
                (movingOffset)="onMovingSocialNetworkItems($event, positions[11])"
                [position]="{ x: positions[11].x, y: positions[11].y }"
              >
              <button (click)="changeSocialMediaPreview('zalo')"
                      [class.active]="currentSocialMediaPreviewing === 'zalo' && this.socialPlatformVisibility['zalo']"
                      class='btn mx-auto social-share-btn-icon'>
                <svg class="zalo-icon" [class.svg_disable]="!this.socialPlatformVisibility['zalo']"  version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 122.88 116.57" xml:space="preserve">
                  <g>
                    <title>Zalo</title>
                    <path class="st1" d="M38.66,113.29c-6.87,0-13.76,0.23-20.63-0.03C9.91,112.94,3.7,106.13,3.7,98c0-26.24,0.05-52.47,0-78.73 c0-8.98,7.02-15.24,15.09-15.47c8.45-0.23,16.93-0.05,25.41-0.05c0.15,0,0.35-0.08,0.43,0.18c-0.05,0.45-0.5,0.5-0.78,0.68 c-4.98,2.92-9.53,6.41-13.36,10.74c-6.31,7.14-10.69,15.34-12.17,24.88c-2.62,16.83,2.64,31.12,14.54,43.04 c2.11,2.14,2.39,3.8,0.7,6.67c-2.04,3.45-5.13,5.79-8.43,7.92c-0.35,0.2-0.7,0.45-1.06,0.68c-0.53,0.45-0.2,0.68,0.25,0.88 c0.1,0.23,0.23,0.43,0.38,0.63c2.89,2.57,5.63,5.31,8.48,7.92c1.33,1.23,2.67,2.51,3.95,3.8 C37.66,112.24,38.54,112.39,38.66,113.29L38.66,113.29L38.66,113.29z"/>
                    <path class="st0" d="M38.66,113.29c-0.13-0.88-1.01-1.03-1.53-1.56c-1.28-1.31-2.62-2.57-3.95-3.8c-2.84-2.62-5.58-5.36-8.48-7.92 c-0.15-0.2-0.28-0.4-0.38-0.63c6.41,1.26,12.68,0.4,18.84-1.48c2.09-0.63,4.18-1.26,6.29-1.79c1.43-0.38,2.94-0.3,4.33,0.2 c15.95,5.48,31.69,4.98,47.19-1.81c6.31-2.79,12.07-6.72,16.95-11.62c0.25-0.25,0.43-0.63,0.88-0.65c0.23,0.35,0.1,0.73,0.1,1.11 v14.71c0.05,8.4-6.69,15.24-15.09,15.32h-0.13c-9.05,0.05-18.11,0-27.17,0H40.17C39.67,113.32,39.17,113.29,38.66,113.29 L38.66,113.29L38.66,113.29z"/>
                    <path class="st1" d="M42.59,57c3.8,0,7.37-0.02,10.92,0c1.99,0.03,3.07,0.86,3.27,2.44c0.23,1.99-0.93,3.32-3.09,3.35 c-4.08,0.05-8.13,0.03-12.2,0.03c-1.18,0-2.34,0.05-3.52-0.03c-1.46-0.08-2.89-0.38-3.6-1.89c-0.7-1.51-0.2-2.87,0.75-4.1 c3.87-4.93,7.77-9.89,11.67-14.82c0.23-0.3,0.45-0.6,0.68-0.88c-0.25-0.43-0.6-0.23-0.91-0.25c-2.72-0.03-5.46,0-8.18-0.03 c-0.63,0-1.26-0.08-1.86-0.2c-1.43-0.33-2.31-1.76-1.99-3.17c0.23-0.96,0.98-1.74,1.94-1.96c0.6-0.15,1.23-0.23,1.86-0.23 c4.48-0.02,8.98-0.02,13.46,0c0.8-0.02,1.58,0.08,2.36,0.28c1.71,0.58,2.44,2.16,1.76,3.82c-0.6,1.43-1.56,2.67-2.52,3.9 c-3.3,4.2-6.59,8.38-9.89,12.53C43.24,56.12,42.99,56.45,42.59,57L42.59,57L42.59,57z"/>
                    <path class="st1" d="M71.77,43.77c0.6-0.78,1.23-1.51,2.26-1.71c1.99-0.4,3.85,0.88,3.87,2.89c0.08,5.03,0.05,10.06,0,15.09 c0,1.31-0.85,2.46-2.09,2.84c-1.26,0.48-2.69,0.1-3.52-0.98c-0.43-0.53-0.6-0.63-1.21-0.15c-2.29,1.86-4.88,2.19-7.67,1.28 c-4.48-1.46-6.31-4.96-6.82-9.21c-0.53-4.6,1.01-8.53,5.13-10.94C65.15,40.85,68.62,41.03,71.77,43.77L71.77,43.77L71.77,43.77z M62.86,52.95c0.05,1.11,0.4,2.16,1.06,3.04c1.36,1.81,3.95,2.19,5.79,0.83c0.3-0.23,0.58-0.5,0.83-0.83 c1.41-1.91,1.41-5.06,0-6.97c-0.71-0.98-1.81-1.56-2.99-1.58C64.77,47.27,62.84,49.4,62.86,52.95L62.86,52.95L62.86,52.95z M89.2,53.1c-0.2-6.46,4.05-11.29,10.09-11.47c6.41-0.2,11.09,4.1,11.29,10.39c0.2,6.36-3.7,10.87-9.71,11.47 C94.3,64.14,89.1,59.39,89.2,53.1L89.2,53.1L89.2,53.1z M95.51,52.5c-0.05,1.26,0.33,2.49,1.08,3.52c1.38,1.81,3.97,2.16,5.79,0.75 c0.28-0.2,0.5-0.45,0.73-0.7c1.46-1.91,1.46-5.13,0.03-7.04c-0.71-0.96-1.81-1.56-2.99-1.58C97.42,47.29,95.51,49.35,95.51,52.5 L95.51,52.5L95.51,52.5z M86.98,48.1c0,3.9,0.03,7.8,0,11.7c0.03,1.79-1.38,3.27-3.17,3.32c-0.3,0-0.63-0.03-0.93-0.1 c-1.26-0.33-2.21-1.66-2.21-3.25v-20c0-1.18-0.03-2.34,0-3.52c0.03-1.94,1.26-3.19,3.12-3.19c1.91-0.02,3.19,1.23,3.19,3.24 C87.01,40.22,86.98,44.17,86.98,48.1L86.98,48.1L86.98,48.1z"/>
                    <path class="st1" d="M20.18,0h82.53c5.57,0,10.61,2.26,14.27,5.91c3.65,3.65,5.91,8.7,5.91,14.27v76.22 c0,5.57-2.26,10.62-5.91,14.27c-3.65,3.65-8.7,5.91-14.27,5.91H20.18c-5.57,0-10.61-2.26-14.27-5.91C2.26,107.01,0,101.96,0,96.39 V20.17C0,14.6,2.26,9.56,5.91,5.91C9.56,2.26,14.6,0,20.18,0L20.18,0z M102.71,7.65H20.18c-3.46,0-6.59,1.4-8.86,3.67 c-2.27,2.27-3.67,5.4-3.67,8.86v76.22c0,3.46,1.4,6.59,3.67,8.86c2.27,2.27,5.4,3.67,8.86,3.67h82.53c3.46,0,6.59-1.4,8.86-3.67 c2.27-2.27,3.67-5.4,3.67-8.86V20.17c0-3.46-1.4-6.59-3.67-8.86C109.29,9.05,106.16,7.65,102.71,7.65L102.71,7.65z"/>
                  </g>
                </svg>
              </button>
              </div>
            </div>
            <div class='d-flex justify-content-center'>
              <div
                class="box-swap"
                appDragBox
                [zIndexMoving]="'9999'"
                (movingOffset)="onMovingSocialNetworkItems($event, positions[12])"
                [position]="{ x: positions[12].x, y: positions[12].y }"
              >
              <button (click)="changeSocialMediaPreview('line')"
                      [class.active]="currentSocialMediaPreviewing === 'line' && this.socialPlatformVisibility['line']"
                      class='btn mx-auto social-share-btn-icon'>
                <svg class="line-icon" [class.svg_disable]="!this.socialPlatformVisibility['line']" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 122.88 122.88" xml:space="preserve">
                  <g>
                    <title>Line</title>
                    <path class="st1" d="M96.26,122.88H26.62C11.92,122.88,0,110.96,0,96.26V26.62C0,11.92,11.92,0,26.62,0h69.63 c14.71,0,26.62,11.92,26.62,26.62v69.63C122.88,110.96,110.96,122.88,96.26,122.88L96.26,122.88z"/>
                    <path class="st0" d="M105.98,56.04c0-20.02-20.07-36.31-44.74-36.31c-24.67,0-44.74,16.29-44.74,36.31 c0,17.95,15.92,32.98,37.42,35.82c1.46,0.31,3.44,0.96,3.94,2.21c0.45,1.13,0.29,2.9,0.14,4.04c0,0-0.52,3.16-0.64,3.83 c-0.2,1.13-0.9,4.42,3.88,2.41c4.77-2.01,25.77-15.17,35.15-25.97h0C102.87,71.26,105.98,64.05,105.98,56.04L105.98,56.04z"/>
                    <path class="st1" d="M52.15,46.36h-3.14c-0.48,0-0.87,0.39-0.87,0.87v19.49c0,0.48,0.39,0.87,0.87,0.87h3.14 c0.48,0,0.87-0.39,0.87-0.87V47.23C53.02,46.75,52.63,46.36,52.15,46.36L52.15,46.36z"/>
                    <path class="st1" d="M73.75,46.36h-3.14c-0.48,0-0.87,0.39-0.87,0.87v11.58l-8.93-12.06c-0.02-0.03-0.04-0.06-0.07-0.09 c0,0,0,0,0-0.01c-0.02-0.02-0.04-0.04-0.05-0.05c-0.01,0-0.01-0.01-0.02-0.02c-0.02-0.01-0.03-0.03-0.05-0.04 c-0.01-0.01-0.01-0.01-0.02-0.02c-0.01-0.01-0.03-0.02-0.04-0.03c-0.01-0.01-0.02-0.01-0.03-0.02c-0.02-0.01-0.03-0.02-0.05-0.03 c-0.01,0-0.02-0.01-0.03-0.01c-0.02-0.01-0.03-0.02-0.05-0.02c-0.01,0-0.02-0.01-0.03-0.01c-0.02-0.01-0.03-0.01-0.05-0.02 c-0.01,0-0.02,0-0.03-0.01c-0.02,0-0.03-0.01-0.05-0.01c-0.01,0-0.02,0-0.04-0.01c-0.02,0-0.03,0-0.05-0.01c-0.02,0-0.03,0-0.04,0 c-0.01,0-0.02,0-0.03,0h-3.14c-0.48,0-0.87,0.39-0.87,0.87v19.49c0,0.48,0.39,0.87,0.87,0.87h3.14c0.48,0,0.87-0.39,0.87-0.87 V55.15l8.94,12.08c0.06,0.09,0.14,0.16,0.22,0.21c0,0,0.01,0,0.01,0.01c0.02,0.01,0.04,0.02,0.05,0.03c0.01,0,0.02,0.01,0.03,0.01 c0.01,0.01,0.03,0.01,0.04,0.02s0.03,0.01,0.04,0.02c0.01,0,0.02,0.01,0.03,0.01c0.02,0.01,0.04,0.01,0.06,0.02c0,0,0.01,0,0.01,0 c0.07,0.02,0.15,0.03,0.22,0.03h3.14c0.48,0,0.87-0.39,0.87-0.87V47.23C74.62,46.75,74.23,46.36,73.75,46.36L73.75,46.36z"/>
                    <path class="st1" d="M44.59,62.71h-8.53V47.23c0-0.48-0.39-0.87-0.87-0.87h-3.14c-0.48,0-0.87,0.39-0.87,0.87v19.49 c0,0.23,0.09,0.45,0.24,0.6c0,0,0.01,0.01,0.01,0.01c0,0,0.01,0.01,0.01,0.01c0.16,0.15,0.37,0.24,0.6,0.24h12.54 c0.48,0,0.87-0.39,0.87-0.87v-3.14C45.46,63.11,45.07,62.71,44.59,62.71L44.59,62.71z"/>
                    <path class="st1" d="M91.08,51.24c0.48,0,0.87-0.39,0.87-0.87v-3.14c0-0.48-0.39-0.87-0.87-0.87H78.54c-0.23,0-0.45,0.09-0.6,0.25 c0,0-0.01,0.01-0.01,0.01c0,0.01-0.01,0.01-0.01,0.02c-0.15,0.16-0.24,0.37-0.24,0.6v19.49c0,0.23,0.09,0.45,0.24,0.6 c0,0,0.01,0.01,0.01,0.01c0,0,0.01,0.01,0.01,0.01c0.16,0.15,0.37,0.25,0.6,0.25h12.54c0.48,0,0.87-0.39,0.87-0.87v-3.14 c0-0.48-0.39-0.87-0.87-0.87h-8.53v-3.29h8.53c0.48,0,0.87-0.39,0.87-0.87v-3.14c0-0.48-0.39-0.87-0.87-0.87h-8.53v-3.29H91.08 L91.08,51.24z"/>
                  </g>
                </svg>
              </button>
              </div>
            </div>
            <div class='d-flex justify-content-center'>
              <div
                class="box-swap"
                appDragBox
                [zIndexMoving]="'9999'"
                (movingOffset)="onMovingSocialNetworkItems($event, positions[13])"
                [position]="{ x: positions[13].x, y: positions[13].y }"
              >
              <button (click)="changeSocialMediaPreview('wechat')"
                      [class.active]="currentSocialMediaPreviewing === 'wechat' && this.socialPlatformVisibility['wechat']"
                      class='btn mx-auto social-share-btn-icon'>
                <svg class="wechat-icon" [class.svg_disable]="!this.socialPlatformVisibility['wechat']" version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24.5 22.88" xml:space="preserve">
                  <g>
                    <title>WeChat</title>
                    <path d="M21.502 19.525c1.524-1.105 2.498-2.738 2.498-4.554 0-3.326-3.237-6.023-7.229-6.023s-7.229 2.697-7.229 6.023c0 3.327 3.237 6.024 7.229 6.024.825 0 1.621-.117 2.36-.33l.212-.032c.139 0 .265.043.384.111l1.583.914.139.045c.133 0 .241-.108.241-.241l-.039-.176-.326-1.215-.025-.154c0-.162.08-.305.202-.392zm-12.827-17.228c-4.791 0-8.675 3.236-8.675 7.229 0 2.178 1.168 4.139 2.997 5.464.147.104.243.276.243.471l-.03.184-.391 1.458-.047.211c0 .16.13.29.289.29l.168-.054 1.899-1.097c.142-.082.293-.133.46-.133l.255.038c.886.255 1.842.397 2.832.397l.476-.012c-.188-.564-.291-1.158-.291-1.771 0-3.641 3.542-6.593 7.911-6.593l.471.012c-.653-3.453-4.24-6.094-8.567-6.094zm5.686 11.711c-.532 0-.963-.432-.963-.964 0-.533.431-.964.963-.964.533 0 .964.431.964.964 0 .532-.431.964-.964.964zm4.82 0c-.533 0-.964-.432-.964-.964 0-.533.431-.964.964-.964.532 0 .963.431.963.964 0 .532-.431.964-.963.964zm-13.398-5.639c-.639 0-1.156-.518-1.156-1.156 0-.639.517-1.157 1.156-1.157.639 0 1.157.518 1.157 1.157 0 .638-.518 1.156-1.157 1.156zm5.783 0c-.639 0-1.156-.518-1.156-1.156 0-.639.517-1.157 1.156-1.157.639 0 1.157.518 1.157 1.157 0 .638-.518 1.156-1.157 1.156z"/>
                    <path d="M21.502 19.525c1.524-1.105 2.498-2.738 2.498-4.554 0-3.326-3.237-6.023-7.229-6.023s-7.229 2.697-7.229 6.023c0 3.327 3.237 6.024 7.229 6.024.825 0 1.621-.117 2.36-.33l.212-.032c.139 0 .265.043.384.111l1.583.914.139.045c.133 0 .241-.108.241-.241l-.039-.176-.326-1.215-.025-.154c0-.162.08-.305.202-.392zm-12.827-17.228c-4.791 0-8.675 3.236-8.675 7.229 0 2.178 1.168 4.139 2.997 5.464.147.104.243.276.243.471l-.03.184-.391 1.458-.047.211c0 .16.13.29.289.29l.168-.054 1.899-1.097c.142-.082.293-.133.46-.133l.255.038c.886.255 1.842.397 2.832.397l.476-.012c-.188-.564-.291-1.158-.291-1.771 0-3.641 3.542-6.593 7.911-6.593l.471.012c-.653-3.453-4.24-6.094-8.567-6.094zm5.686 11.711c-.532 0-.963-.432-.963-.964 0-.533.431-.964.963-.964.533 0 .964.431.964.964 0 .532-.431.964-.964.964zm4.82 0c-.533 0-.964-.432-.964-.964 0-.533.431-.964.964-.964.532 0 .963.431.963.964 0 .532-.431.964-.963.964zm-13.398-5.639c-.639 0-1.156-.518-1.156-1.156 0-.639.517-1.157 1.156-1.157.639 0 1.157.518 1.157 1.157 0 .638-.518 1.156-1.157 1.156zm5.783 0c-.639 0-1.156-.518-1.156-1.156 0-.639.517-1.157 1.156-1.157.639 0 1.157.518 1.157 1.157 0 .638-.518 1.156-1.157 1.156z"/>
                  </g>
                </svg>
              </button>
              </div>
            </div>
            <div class='d-flex justify-content-center'>
              <div
                class="box-swap"
                appDragBox
                [zIndexMoving]="'9999'"
                (movingOffset)="onMovingSocialNetworkItems($event, positions[14])"
                [position]="{ x: positions[14].x, y: positions[14].y }"
              >
                <button (click)="changeSocialMediaPreview('telegram')"
                        [class]="{active: currentSocialMediaPreviewing === 'telegram' && this.socialPlatformVisibility['telegram'],
                        disable: !this.socialPlatformVisibility['telegram'] }"
                        class='btn mx-auto social-share-btn-icon'>
                  <i class='fab fa-telegram' title="Telegram"></i>
                </button>
              </div>
            </div>
            <div class='d-flex justify-content-center'>
              <div
                class="box-swap"
                appDragBox
                [zIndexMoving]="'9999'"
                (movingOffset)="onMovingSocialNetworkItems($event, positions[15])"
                [position]="{ x: positions[15].x, y: positions[15].y }"
              >
                <button (click)="changeSocialMediaPreview('vk')"
                        [class]="{active: currentSocialMediaPreviewing === 'vk' && this.socialPlatformVisibility['vk'],
                        disable: !this.socialPlatformVisibility['vk'] }"
                        class='btn mx-auto social-share-btn-icon'>
                  <svg class="vk-icon" [class.svg_disable]="!this.socialPlatformVisibility['vk']" xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
                    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
                      <title>VK</title>
                      <path d="M1855 5109 c-425 -20 -972 -69 -1069 -94 -267 -70 -489 -249 -608 -490 -43 -86 -74 -180 -88 -265 -23 -145 -60 -619 -80 -1020 -13 -256 -13 -1098 0 -1370 22 -448 68 -980 95 -1084 41 -157 115 -292 224 -408 122 -130 258 -214 427 -263 129 -37 603 -81 1153 -106 295 -13 1287 -7 1536 10 759 52 912 74 1078 157 137 69 274 187 355 305 110 161 145 286 177 619 46 481 57 712 62 1296 7 689 -11 1116 -67 1684 -21 206 -34 272 -77 379 -61 152 -186 312 -319 407 -80 57 -230 127 -318 148 -120 29 -624 73 -1096 96 -243 11 -1143 11 -1385 -1z m846 -1639 c63 -12 96 -34 124 -81 19 -32 20 -53 20 -374 0 -381 2 -397 61 -403 28 -3 39 5 93 65 34 37 91 109 126 158 65 90 192 328 235 440 33 84 55 113 98 125 50 14 557 13 622 -1 90 -19 102 -79 42 -212 -41 -89 -82 -151 -268 -403 -164 -222 -214 -301 -214 -336 0 -35 22 -62 190 -233 229 -234 330 -372 330 -452 0 -49 -22 -80 -74 -104 -36 -17 -68 -19 -291 -19 -274 0 -335 8 -410 56 -22 15 -114 102 -205 194 -127 130 -172 170 -198 175 -71 14 -96 -31 -131 -234 -31 -177 -47 -186 -300 -178 -188 6 -280 24 -421 84 -110 46 -254 142 -354 235 -201 185 -449 559 -665 1003 -161 328 -174 372 -130 416 20 20 29 20 297 17 365 -4 318 25 461 -282 91 -194 258 -447 331 -501 99 -73 130 5 130 333 0 118 -5 222 -11 248 -15 58 -54 99 -110 115 -61 17 -76 32 -61 63 14 31 68 72 112 84 46 13 503 15 571 2z"/>
                    </g>
                  </svg>
                </button>
              </div>
            </div>
            <div class='d-flex justify-content-center'>
              <div
                class="box-swap"
                appDragBox
                [zIndexMoving]="'9999'"
                (movingOffset)="onMovingSocialNetworkItems($event, positions[16])"
                [position]="{ x: positions[16].x, y: positions[16].y }"
              >
                <button (click)="changeSocialMediaPreview('viber')"
                        [class]="{active: currentSocialMediaPreviewing === 'viber' && this.socialPlatformVisibility['viber'],
                        disable: !this.socialPlatformVisibility['viber'] }"
                        class='btn mx-auto social-share-btn-icon'>
                  <svg class="viber-icon" [class.svg_disable]="!this.socialPlatformVisibility['viber']" xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 840.000000 859.000000" preserveAspectRatio="xMidYMid meet">
                    <g transform="translate(0.000000,859.000000) scale(0.100000,-0.100000)">
                      <title>Viber</title>
                      <path d="M3859 8106 c-3 -3 -61 -12 -130 -21 -196 -24 -338 -48 -384 -65 -11 -4 -54 -15 -95 -25 -77 -18 -159 -41 -195 -55 -51 -19 -122 -40 -137 -40 -10 0 -18 -3 -18 -8 0 -7 -53 -28 -100 -39 -14 -3 -27 -9 -30 -12 -3 -4 -44 -22 -92 -41 -49 -19 -88 -38 -88 -42 0 -5 -5 -8 -10 -8 -15 0 -144 -63 -148 -72 -2 -5 -10 -8 -18 -8 -13 0 -54 -22 -109 -58 -11 -7 -28 -15 -37 -18 -10 -4 -18 -10 -18 -15 0 -5 -6 -9 -14 -9 -8 0 -21 -6 -28 -12 -16 -15 -47 -35 -68 -45 -8 -4 -19 -11 -25 -15 -29 -24 -127 -88 -135 -88 -4 0 -10 -4 -12 -8 -1 -5 -30 -28 -63 -53 -33 -24 -62 -46 -65 -49 -3 -3 -21 -18 -40 -33 -167 -135 -431 -399 -567 -567 -15 -19 -31 -36 -35 -38 -5 -2 -8 -10 -8 -18 0 -8 -3 -14 -7 -14 -5 0 -24 -23 -43 -50 -19 -27 -38 -50 -42 -50 -5 0 -8 -4 -8 -10 0 -7 -48 -82 -87 -136 -15 -20 -33 -49 -40 -64 -4 -8 -13 -21 -20 -28 -7 -7 -13 -20 -13 -28 0 -8 -4 -14 -9 -14 -5 0 -11 -8 -15 -17 -3 -10 -11 -27 -18 -38 -36 -55 -58 -96 -58 -109 0 -8 -3 -16 -8 -18 -9 -4 -72 -133 -72 -148 0 -5 -4 -10 -10 -10 -5 0 -10 -5 -10 -11 0 -5 -11 -35 -25 -64 -13 -30 -27 -66 -31 -80 -3 -14 -10 -25 -15 -25 -5 0 -9 -8 -9 -19 0 -10 -7 -32 -15 -47 -8 -16 -15 -37 -15 -46 0 -10 -4 -18 -10 -18 -5 0 -10 -8 -10 -18 0 -10 -11 -50 -24 -88 -31 -89 -50 -152 -71 -239 -9 -38 -21 -78 -26 -87 -5 -10 -9 -30 -9 -45 0 -16 -5 -44 -10 -63 -11 -36 -18 -80 -48 -290 -25 -180 -25 -770 0 -950 30 -210 37 -254 48 -290 5 -19 10 -50 10 -67 0 -18 5 -33 10 -33 6 0 10 -10 10 -22 1 -31 53 -223 89 -323 11 -32 21 -67 21 -77 0 -10 5 -18 10 -18 6 0 10 -8 10 -17 0 -10 7 -31 15 -47 8 -15 15 -37 15 -47 0 -11 4 -19 9 -19 5 0 12 -11 15 -25 4 -14 18 -50 31 -80 14 -29 25 -59 25 -64 0 -6 5 -11 10 -11 6 0 10 -5 10 -10 0 -15 63 -144 72 -148 5 -2 8 -10 8 -18 0 -7 18 -43 40 -79 22 -36 40 -70 40 -75 0 -6 5 -10 10 -10 6 0 10 -6 10 -14 0 -8 6 -21 13 -28 14 -16 34 -47 44 -68 4 -8 11 -19 15 -25 25 -30 88 -127 88 -135 0 -6 3 -10 8 -10 4 0 23 -23 42 -50 19 -27 38 -50 43 -50 4 0 7 -6 7 -14 0 -8 3 -16 8 -18 4 -2 20 -19 35 -38 138 -170 440 -472 566 -565 19 -14 37 -28 40 -33 3 -4 33 -27 66 -51 33 -25 62 -48 63 -53 2 -4 7 -8 12 -8 7 0 129 -78 140 -90 7 -7 41 -28 60 -37 8 -4 21 -13 28 -20 7 -7 20 -13 28 -13 8 0 14 -4 14 -9 0 -5 8 -11 18 -15 9 -3 26 -11 37 -18 50 -33 96 -58 105 -58 6 0 27 -10 48 -23 20 -13 57 -32 82 -42 25 -11 47 -22 50 -26 3 -3 43 -21 90 -40 47 -19 87 -37 90 -40 3 -3 16 -9 30 -12 47 -11 100 -32 100 -39 0 -5 8 -8 18 -8 16 0 88 -21 137 -41 11 -4 47 -15 80 -24 33 -9 71 -21 85 -26 14 -4 43 -11 65 -14 22 -4 49 -10 60 -14 22 -9 120 -30 200 -42 267 -41 311 -44 660 -44 193 0 377 4 410 8 33 4 92 12 130 17 116 15 198 30 229 40 16 6 44 10 62 10 18 0 36 5 39 10 3 6 17 10 29 10 13 0 48 7 77 16 30 8 79 23 109 31 30 9 80 25 110 36 30 10 67 21 83 24 15 3 27 9 27 14 0 5 9 9 20 9 10 0 36 7 57 16 21 9 47 20 58 25 35 14 118 51 193 85 41 19 77 34 82 34 5 0 10 3 12 8 2 4 35 23 73 42 39 19 72 37 75 40 7 7 43 29 60 37 29 13 145 87 148 95 2 4 8 8 13 8 6 0 34 18 64 40 30 22 58 40 64 40 5 0 11 4 13 8 2 5 30 28 63 53 33 24 62 46 65 49 3 3 25 21 50 40 24 19 56 46 71 60 14 14 48 44 75 67 112 95 328 322 415 438 13 17 26 32 29 35 3 3 25 32 49 65 25 33 48 62 53 63 4 2 8 8 8 13 0 6 18 34 40 64 22 30 40 59 40 65 0 5 3 10 8 10 4 0 16 17 27 38 11 20 26 43 32 50 7 7 13 20 13 28 0 8 4 14 9 14 5 0 11 8 15 17 5 18 26 53 36 63 3 3 21 37 40 75 19 39 38 72 43 73 4 2 7 8 7 14 0 6 15 43 34 82 58 122 76 164 76 180 0 9 5 16 10 16 6 0 10 10 10 23 0 12 7 31 15 41 8 11 15 30 15 43 0 13 4 23 9 23 5 0 11 12 14 28 2 15 10 43 17 62 25 68 27 75 43 130 8 30 23 79 31 109 9 29 16 63 16 75 0 12 4 26 9 31 5 6 11 28 14 50 3 22 12 76 21 120 41 200 51 329 51 695 0 279 -4 382 -17 480 -26 187 -58 367 -69 385 -4 6 -10 32 -14 59 -3 27 -10 58 -15 70 -4 11 -16 48 -25 81 -9 33 -28 91 -41 129 -13 38 -24 78 -24 88 0 10 -3 18 -8 18 -7 0 -28 53 -39 100 -3 14 -9 27 -12 30 -4 3 -22 44 -41 93 -19 48 -38 87 -42 87 -5 0 -8 6 -8 13 0 16 -101 214 -134 264 -14 21 -26 43 -26 50 0 7 -4 13 -10 13 -5 0 -10 6 -10 14 0 8 -6 21 -12 28 -15 17 -36 47 -45 68 -4 8 -9 17 -13 20 -11 9 -90 132 -90 141 0 5 -3 9 -7 9 -5 0 -24 23 -43 50 -19 27 -38 50 -42 50 -5 0 -8 7 -8 15 0 8 -4 15 -8 15 -5 0 -22 19 -39 43 -84 116 -427 461 -549 551 -22 16 -43 34 -49 40 -5 6 -37 31 -70 55 -33 25 -61 48 -63 53 -2 4 -7 8 -12 8 -7 0 -129 78 -140 90 -7 7 -41 28 -60 37 -8 4 -21 13 -28 20 -7 7 -20 13 -28 13 -8 0 -14 5 -14 10 0 6 -6 10 -14 10 -8 0 -21 6 -28 13 -27 24 -264 147 -285 147 -7 0 -13 5 -13 10 0 6 -5 10 -11 10 -5 0 -35 11 -64 25 -30 13 -66 27 -80 31 -14 3 -25 10 -25 14 0 4 -12 10 -27 13 -44 9 -103 31 -103 39 0 5 -9 8 -20 8 -17 0 -63 15 -125 40 -11 5 -40 13 -65 20 -25 6 -61 16 -80 22 -19 5 -61 15 -92 21 -32 6 -58 14 -58 19 0 4 -15 8 -32 8 -18 0 -51 5 -73 11 -48 12 -122 24 -270 45 -108 16 -823 32 -836 20z m826 -1466 c213 -24 314 -38 335 -46 8 -3 35 -9 60 -14 25 -5 74 -16 110 -25 36 -8 76 -18 90 -21 14 -3 34 -9 45 -14 39 -16 180 -62 208 -67 15 -3 27 -9 27 -14 0 -5 5 -9 12 -9 11 0 138 -60 148 -70 10 -10 45 -31 63 -36 9 -4 17 -10 17 -14 0 -4 10 -12 23 -17 12 -6 38 -24 57 -39 40 -33 178 -169 200 -199 8 -11 30 -39 48 -61 17 -23 32 -46 32 -52 0 -6 3 -12 8 -14 4 -1 22 -31 39 -66 18 -34 37 -70 42 -80 19 -35 40 -89 66 -172 16 -47 31 -94 35 -105 13 -34 56 -248 70 -345 52 -349 39 -953 -29 -1360 -16 -98 -62 -267 -91 -335 -5 -11 -16 -38 -25 -60 -20 -48 -22 -53 -65 -130 -18 -33 -56 -91 -84 -130 -78 -108 -262 -285 -295 -285 -6 0 -11 -4 -11 -8 0 -14 -193 -122 -217 -122 -7 0 -13 -4 -13 -8 0 -4 -26 -16 -57 -26 -32 -10 -65 -21 -73 -25 -21 -11 -112 -37 -195 -56 -38 -9 -86 -20 -105 -25 -265 -68 -699 -106 -1091 -94 l-226 6 -49 -49 c-42 -42 -80 -84 -167 -187 -10 -11 -53 -59 -95 -106 -180 -197 -223 -230 -302 -230 -72 0 -114 23 -155 85 -19 28 -20 52 -25 329 l-5 299 -30 9 c-16 5 -39 13 -50 18 -11 5 -42 16 -70 26 -64 23 -231 109 -272 140 -17 13 -36 24 -42 24 -5 0 -14 6 -18 13 -4 6 -24 24 -43 38 -48 36 -137 124 -185 184 -22 28 -43 52 -47 53 -5 2 -8 7 -8 12 0 4 -16 31 -34 59 -19 28 -56 95 -81 149 -26 53 -51 105 -56 114 -5 10 -9 27 -9 37 0 11 -4 22 -9 25 -5 3 -12 22 -16 42 -3 20 -10 44 -15 53 -8 16 -27 100 -49 211 -15 78 -39 267 -48 390 -10 135 -10 506 0 635 11 145 37 355 48 391 5 17 9 43 9 59 0 26 16 98 40 180 4 17 11 45 15 62 4 18 11 35 16 38 5 4 9 15 9 26 0 10 4 27 10 37 5 9 17 35 26 57 35 85 106 218 130 246 8 8 14 20 14 26 0 6 3 13 8 15 4 2 23 23 42 48 19 25 64 74 100 108 68 66 224 182 246 182 7 0 14 3 16 8 3 6 116 63 163 82 11 4 33 13 50 19 16 7 56 21 90 32 33 11 69 24 80 29 11 5 31 11 45 14 102 22 140 32 146 39 4 4 19 7 34 7 15 0 40 5 56 10 33 11 103 22 314 49 219 28 769 28 1015 1z"/>
                      <path d="M3935 6299 c-220 -8 -549 -54 -640 -89 -11 -4 -49 -16 -85 -25 -59 -16 -88 -26 -160 -57 -51 -22 -95 -43 -100 -48 -3 -3 -27 -16 -53 -30 -27 -14 -57 -33 -67 -42 -11 -10 -22 -18 -25 -18 -9 0 -30 -19 -113 -101 -86 -85 -92 -92 -137 -159 -115 -171 -185 -427 -228 -830 -15 -148 -15 -572 1 -720 21 -204 63 -432 92 -505 4 -11 15 -40 25 -65 90 -234 266 -429 490 -542 64 -33 173 -78 188 -78 19 -1 56 -36 65 -61 5 -13 7 -187 5 -388 -5 -353 0 -440 23 -448 13 -4 94 74 179 172 53 61 97 112 130 149 6 6 32 38 60 71 27 33 54 65 60 71 5 6 33 37 60 69 28 32 56 64 63 71 6 7 12 15 12 18 0 7 97 105 124 126 15 12 80 16 345 22 390 8 606 32 901 103 36 9 76 18 90 21 14 3 34 9 45 13 11 5 58 23 105 41 47 18 87 36 90 39 3 3 23 15 45 26 22 11 46 26 53 32 7 7 17 13 21 13 4 0 16 8 27 18 10 9 39 32 64 51 25 19 63 56 85 84 22 27 48 58 58 68 9 11 17 24 17 29 0 6 4 10 8 10 12 0 122 225 122 249 0 6 4 19 9 29 5 9 16 53 26 97 9 44 21 98 26 120 25 111 45 288 58 520 13 226 -4 522 -43 740 -34 194 -47 246 -80 335 -10 25 -20 54 -23 65 -10 33 -82 165 -111 203 -15 20 -34 46 -42 57 -19 25 -108 114 -140 140 -125 101 -257 164 -455 219 -91 26 -123 33 -210 50 -123 24 -127 24 -385 55 -115 14 -456 19 -675 10z m431 -488 c51 -5 107 -14 125 -19 19 -6 61 -19 94 -28 33 -10 67 -20 75 -24 8 -4 56 -27 105 -51 50 -24 92 -46 95 -49 3 -4 25 -20 50 -35 51 -32 260 -234 260 -252 0 -6 3 -13 8 -15 10 -4 63 -85 87 -133 11 -22 22 -42 25 -45 16 -15 76 -189 99 -287 12 -49 23 -141 37 -293 5 -57 3 -68 -16 -92 -31 -40 -72 -38 -103 5 -24 33 -40 110 -52 252 -6 70 -13 103 -42 205 -19 63 -92 223 -104 228 -5 2 -9 8 -9 14 0 11 -60 91 -72 96 -5 2 -8 8 -8 14 0 9 -88 99 -141 143 -72 61 -219 139 -319 171 -30 9 -64 21 -75 25 -25 9 -238 39 -281 39 -22 0 -41 9 -63 32 -36 37 -38 48 -13 68 51 45 67 51 107 45 22 -3 81 -9 131 -14z m-945 -125 c43 -19 83 -56 139 -131 24 -33 50 -66 57 -73 7 -7 13 -16 13 -20 0 -4 10 -19 23 -34 13 -15 36 -47 52 -72 16 -26 33 -46 37 -46 4 0 8 -4 8 -9 0 -5 15 -32 34 -59 45 -68 73 -155 58 -185 -6 -12 -14 -32 -17 -45 -7 -23 -77 -99 -134 -142 -36 -28 -71 -87 -71 -121 0 -22 31 -120 40 -129 3 -3 14 -25 25 -50 45 -105 141 -243 232 -335 70 -71 225 -185 251 -185 3 0 29 -11 57 -24 122 -58 200 -71 245 -39 14 10 59 53 102 95 42 43 93 85 114 94 50 21 112 11 184 -28 53 -29 262 -175 298 -208 9 -9 35 -29 57 -45 83 -61 125 -120 125 -176 0 -40 -43 -133 -92 -199 -48 -64 -157 -170 -174 -170 -7 0 -14 -3 -16 -7 -1 -5 -21 -17 -42 -28 -52 -26 -171 -27 -241 0 -27 10 -54 22 -60 27 -5 4 -15 8 -21 8 -30 0 -444 204 -452 223 -2 4 -10 7 -17 7 -8 0 -20 6 -27 13 -7 6 -30 21 -50 32 -21 11 -38 23 -38 27 0 5 -5 8 -10 8 -12 0 -165 109 -245 174 -137 112 -306 281 -395 396 -19 25 -38 47 -42 48 -5 2 -8 10 -8 18 0 8 -3 14 -7 14 -5 0 -19 18 -33 40 -13 22 -28 40 -32 40 -4 0 -8 5 -8 11 0 6 -11 25 -24 42 -23 32 -66 107 -115 202 -14 28 -29 52 -33 53 -5 2 -8 10 -8 17 0 16 -32 79 -42 83 -5 2 -8 9 -8 16 0 7 -10 33 -23 57 -13 24 -38 80 -57 124 -19 44 -42 95 -53 114 -10 18 -22 52 -27 75 -5 22 -12 53 -16 68 -11 47 58 171 141 253 84 84 105 101 170 141 94 58 120 64 176 40z m980 -186 c46 -6 91 -16 100 -21 10 -5 26 -9 36 -9 10 0 41 -12 68 -25 28 -14 53 -25 57 -25 11 0 112 -63 116 -72 2 -4 9 -8 14 -8 13 0 168 -157 168 -170 0 -5 6 -15 13 -22 12 -12 67 -121 86 -173 51 -131 65 -343 24 -376 -21 -18 -80 -16 -99 3 -10 10 -18 47 -24 114 -13 148 -19 173 -56 247 -8 16 -14 33 -14 39 0 9 -49 84 -80 121 -55 68 -165 147 -250 181 -25 10 -54 22 -65 27 -11 4 -65 16 -120 25 -88 16 -103 22 -127 49 -15 16 -28 36 -28 43 0 26 64 75 87 67 6 -2 49 -9 94 -15z m110 -327 c152 -48 253 -172 279 -342 13 -80 5 -104 -46 -137 -24 -16 -27 -16 -51 3 -21 15 -30 36 -45 103 -36 169 -73 206 -249 245 -61 14 -80 22 -90 41 -10 19 -10 29 0 47 30 56 105 71 202 40z"/>
                    </g>
                  </svg>
                </button>
              </div>
            </div>
            <div class='d-flex justify-content-center'>
              <div
                class="box-swap"
                appDragBox
                [zIndexMoving]="'9999'"
                (movingOffset)="onMovingSocialNetworkItems($event, positions[17])"
                [position]="{ x: positions[17].x, y: positions[17].y }"
              >
                <button (click)="changeSocialMediaPreview('signal')"
                        [class]="{active: currentSocialMediaPreviewing === 'signal' && this.socialPlatformVisibility['signal'],
                        disable: !this.socialPlatformVisibility['signal'] }"
                        class='btn mx-auto social-share-btn-icon'>
                  <svg class="signal-icon" [class.svg_disable]="!this.socialPlatformVisibility['signal']" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <title>Signal</title>
                    <path d="M12 2.25a9.75 9.75 0 0 0-8.539 14.459l-1.013 4.779 4.843-.989A9.75 9.75 0 1 0 12 2.25zm0-2.25a12 12 0 1 1-5.045 22.89L.51 24l1.393-6.238A12 12 0 0 1 12 0z"/>
                  </svg>
                </button>
              </div>
            </div>
            <div class='d-flex justify-content-center'>
              <div
                class="box-swap"
                appDragBox
                [zIndexMoving]="'9999'"
                (movingOffset)="onMovingSocialNetworkItems($event, positions[18])"
                [position]="{ x: positions[18].x, y: positions[18].y }"
              >
                <button (click)="changeSocialMediaPreview('tiktok')"
                        [class]="{active: currentSocialMediaPreviewing === 'tiktok' && this.socialPlatformVisibility['tiktok'],
                        disable: !this.socialPlatformVisibility['tiktok'] }"
                        class='btn mx-auto social-share-btn-icon'>
                  <svg class="tiktok-icon" [class.svg_disable]="!this.socialPlatformVisibility['tiktok']" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <title>TikTok</title>
                    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-2.05-.07-4.1-.65-5.82-1.9-.01 2.92.01 5.84-.02 8.75-.2 3.74-3.4 6.95-7.26 7.15-4.04.22-7.55-2.9-7.74-6.73-.2-4.09 3.46-7.7 7.75-7.18.02 1.48-.04 2.96-.04 4.44-1.91-.61-3.93.76-3.54 2.72.24 1.64 1.82 3.02 3.5 2.87 1.71-.02 3.17-1.5 3.18-3.15.11-5.31.01-10.63.08-15.94z"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>

        </div>
        <div class='accordion' id='contentSectionAccordion'>
          <div class='card card-box'>
            <div class='card-header py-0 pe-0 ps-3 header-color section-header-toggle' id='headingContent'
                 (click)="sectionsStatus['content'] = !sectionsStatus['content']">
              <small>{{currentSocialMediaPreviewing === 'email' ? 'Email Invite' : 'Social Post'}}</small>
              <button class='btn btn-link ms-auto' type='button'
                      [attr.aria-expanded]="sectionsStatus['content']" aria-controls='contentSectionContainer'>
                <i class='fa fa-{{ !sectionsStatus["content"] ? "plus" : "minus" }}'></i>
              </button>
            </div>
            <div class='pt-3 collapse modern-settings-section' id='contentSectionContainer' aria-labelledby='headingContent'
                 [class.show]="sectionsStatus['content']">
              <div class='settings-group'>
                <div class='row'>
                  <div class='col-md-11 mb-3 mx-auto'>
                    <div class='widget-setting-row position-relative'>
                      <div class="widget-setting-icon">
                        <i class="fa fa-share-alt" aria-hidden="true"></i>
                      </div>
                      <div class="widget-setting-main">
                        <div class="widget-setting-title">Active</div>
                        <div class="widget-setting-description">Enable the message for the selected social channel</div>
                        <div class="widget-setting-control-actions">
                          <button class="btn widget-secondary-button"
                                  [class.social-share-btn]="socialShareInfo && !socialShareSkip"
                                  [disabled]="!this.socialPlatformVisibility[currentSocialMediaPreviewing]"
                                  (click)="applyToOthers();onSkip()">Use in all social channels
                          </button>
                        </div>
                      </div>
                      <label class="widget-toggle">
                        <input placeholder=""
                               [checked]="this.socialPlatformVisibility[currentSocialMediaPreviewing]"
                               (change)="changeCheckBox($event)"
                               type="checkbox">
                        <span></span>
                      </label>
                      @if (!socialShareSkip) {
                      <div class='social-share-tooltip'
                           [style.display]="socialShareInfo ? 'block' : 'none'"
                          >
                        Please click here to use the same social message for all the other social networks
                        <button type="button" class="btn btn-default btn-sm" (click)="onSkip()">Skip</button>
                      </div>
                      }
                    </div>
                  </div>
                </div>
                @if (currentSocialMediaPreviewing === 'email') {
                <div class='row'
                    >
                  <div class='col-md-11 mb-3 mx-auto'>
                    <div class="widget-setting-row widget-setting-field-row">
                      <div class="widget-setting-icon"><i class="fa fa-envelope-o" aria-hidden="true"></i></div>
                      <div class="widget-setting-main">
                        <div class="widget-setting-title-row">
                          <div class="widget-setting-title">Subject Line</div>
                          <app-variables (onVariableForClick)="onAddVariablesButtonClick($event)"
                                         [variableClickFor]="'title'"
                                         (onVariableClick)="onVariableClick($event, title)"></app-variables>
                          <app-sb-text-condition-button [target]="title"></app-sb-text-condition-button>
                        </div>
                        <div class="widget-setting-description">Set the subject shown in the email invitation</div>
                        <div class='widget-setting-control input-group input-group-sm variable-input'>
                          <textarea id="test-id" class="form-control overflow-hidden auto-grow-textarea" #title
                                    [disabled]="!this.socialPlatformVisibility[currentSocialMediaPreviewing]"
                                    [(ngModel)]="socialMedias[currentSocialMediaPreviewing]['title']"
                                    (ngModelChange)="onSettingsChange($event, 4, false)"
                                    type="text" (input)="autoGrow(title);"
                                    [rows]="socialMedias[currentSocialMediaPreviewing]['title'] ? 2 : 1"></textarea>
                        </div>
                        <app-sb-text-condition-hint [text]="socialMedias[currentSocialMediaPreviewing]['title']" [target]="title"
                                                    [disabled]="!this.socialPlatformVisibility[currentSocialMediaPreviewing]"></app-sb-text-condition-hint>
                      </div>
                    </div>
                  </div>
                </div>
                }
                <div class='row'>
                  <div class='col-md-11 mb-3 mx-auto'>
                    <div class="widget-setting-row widget-setting-field-row">
                      <div class="widget-setting-icon"><i class="fa fa-commenting-o" aria-hidden="true"></i></div>
                      <div class="widget-setting-main">
                        <div class="widget-setting-title-row">
                          <div class="widget-setting-title">{{getPreText()}}
                            @if (getMaxLength(currentSocialMediaPreviewing) > 0) {
                            <span> ({{getCharacterCount(currentSocialMediaPreviewing)}} /{{getMaxLength(currentSocialMediaPreviewing)}})</span>
                            }
                          </div>
                          <app-variables (onVariableForClick)="onAddVariablesButtonClick($event)"
                                         [variableClickFor]="'message'"
                                         (onVariableClick)="onVariableClick($event, message)"></app-variables>
                          <app-sb-text-condition-button [target]="message" (applied)="validateSocialMessage()"></app-sb-text-condition-button>
                          <button type="button" class="info-button pt-1" [ngbPopover]="popInfoTemplate" data-html="true"
                                  triggers="mouseenter:mouseleave" placement="auto" [container]="'body'"
                                  [popoverClass]="'info-popover'" (click)="applyRTLEmbedding(message, 'social', currentSocialMediaPreviewing)">
                            <i class="fa fa-paragraph"></i>
                          </button>
                          <ng-template #popInfoTemplate>
                            <p class="mb-0">
                              Move the text cursor before the English word inside the RTL text and click the button.
                              This would make the RTL texts to show properly when they're mixed with LTR characters.
                            </p>
                          </ng-template>
                        </div>
                        <div class="widget-setting-description">Customize the message shared on this channel</div>
                        <div class='widget-setting-control input-group input-group-sm variable-textarea'>
                          <textarea class="form-control overflow-hidden auto-grow-textarea" type='text' #message
                                    (keyup)="validateSocialMessage()" (input)="autoGrow(message)"
                                    [maxlength]="getMessageMaxLength(currentSocialMediaPreviewing)"
                                    [disabled]="!this.socialPlatformVisibility[currentSocialMediaPreviewing]"
                                    rows="5" [(ngModel)]="socialMedias[currentSocialMediaPreviewing]['message']"
                                    [class.over-limit]="(getMaxLength(currentSocialMediaPreviewing) > 0 && getCharacterCount(currentSocialMediaPreviewing) > getMaxLength(currentSocialMediaPreviewing))"
                                    (ngModelChange)="onSettingsChange($event, 4, false)">
                          </textarea>
                        </div>
                        <app-sb-text-condition-hint [text]="socialMedias[currentSocialMediaPreviewing]['message']" [target]="message"
                                                    [disabled]="!this.socialPlatformVisibility[currentSocialMediaPreviewing]"
                                                    [requiredTokens]="isCampaignPageUrlRenderedForSocialNetwork(currentSocialMediaPreviewing) ? [influencerCampaignPageUrlVariable] : []"
                                                    (applied)="validateSocialMessage()"></app-sb-text-condition-hint>
                        @if (!isCampaignPageUrlRenderedForSocialNetwork(currentSocialMediaPreviewing) &&
                               socialMessageContainsCampaignPageUrl(currentSocialMediaPreviewing)) {
<div class="widget-setting-description social-message-variable-hint text-muted mt-2"
                            >
                          {{socialNetworkLabel(currentSocialMediaPreviewing)}} doesn't support clickable links in posts, so
                          {{influencerCampaignPageUrlVariable}} is left out of this post. You can remove it and any text that introduces it.
                        </div>
}
                        @if (socialMessageError[currentSocialMediaPreviewing]) {
                        <div class="bar error-brd">
                          <div class="invalid-text">Variable {{influencerCampaignPageUrlVariable}} must be included in the message</div>
                        </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

                <div class="accordion" id="campaignSectionAccordion">
          <div class="card card-box">
            <div class='card-header py-0 pe-0 ps-3 header-color section-header-toggle' id='headingCampaign'
                 (click)="sectionsStatus['campaign'] = !sectionsStatus['campaign']">
              <small>Meta</small>
              <button class='btn btn-link ms-auto' type='button'
                      [attr.aria-expanded]="sectionsStatus['campaign']" aria-controls='campaignSectionContainer'>
                <i class='fa fa-{{ !sectionsStatus["campaign"] ? "plus" : "minus" }}'></i>
              </button>
            </div>
            <div class="pt-3 collapse modern-settings-section" id="campaignSectionContainer" aria-labelledby="headingCampaign"
                 [class.show]="sectionsStatus['campaign']">
              <div class="settings-group influencer-fields-section">
                <div class='row d-none'>
                  <div class='col-md-11 mb-3 mx-auto'>
                    <button class="btn btn-default btn-sm" (click)="applyToOthers()">Apply to the others</button>
                  </div>
                </div>
                <div class="row">
                  <div class='col-md-11 mb-3 mx-auto'>
                    <div class="widget-setting-row widget-setting-field-row">
                      <div class="widget-setting-icon"><i class="fa fa-tag" aria-hidden="true"></i></div>
                      <div class="widget-setting-main">
                        <div class="widget-setting-title-row">
                          <div class="widget-setting-title">Title</div>
                          <app-variables (onVariableForClick)="onMetaVariablesButtonClick($event)"
                                         [variableClickFor]="'meta_title'"
                                         (onVariableClick)="onVariableClick($event, metaTitle)">
                          </app-variables>
                          <app-sb-text-condition-button [target]="metaTitle" (applied)="updateValue({target: metaTitle}, 'title')"></app-sb-text-condition-button>
                          <button type="button" class="info-button pt-1" [ngbPopover]="popInfoTemplate2" data-html="true"
                                  triggers="mouseenter:mouseleave" placement="auto" [container]="'body'"
                                  [popoverClass]="'info-popover'" (click)="applyRTLEmbedding(metaTitle, 'title')">
                            <i class="fa fa-paragraph"></i>
                          </button>
                          <ng-template #popInfoTemplate2>
                            <p class="mb-0">
                              Move the text cursor before the English word inside the RTL text and click the button.
                              This would make the RTL texts to show properly when they're mixed with LTR characters.
                            </p>
                          </ng-template>
                        </div>
                        <div class="widget-setting-description">Set the title used for link previews and campaign metadata</div>
                        <div class='widget-setting-control input-group input-group-sm variable-input'>
                          <input class="form-control" type='text' #metaTitle
                                 [value]="campaignMeta.title"
                                 (keyup)="updateValue($event, 'title')"/>
                        </div>
                        <app-sb-text-condition-hint [text]="campaignMeta.title" [target]="metaTitle"
                                                    (applied)="updateValue({target: metaTitle}, 'title')"></app-sb-text-condition-hint>
                      </div>
                    </div>
                  </div>
                </div>
                <div class='row'>
                  <div class='col-md-11 mb-3 mx-auto'>
                    <div class="widget-setting-row widget-setting-field-row">
                      <div class="widget-setting-icon"><i class="fa fa-align-left" aria-hidden="true"></i></div>
                      <div class="widget-setting-main">
                        <div class="widget-setting-title-row">
                          <div class="widget-setting-title">Description ({{getDescriptionCharacterCount()}} /{{metaDescriptionMaxLength}})</div>
                          <app-variables (onVariableForClick)="onMetaVariablesButtonClick($event)"
                                         [variableClickFor]="'description'"
                                         (onVariableClick)="onVariableClick($event, description)">
                          </app-variables>
                          <app-sb-text-condition-button [target]="description" (applied)="updateValue({target: description}, 'description')"></app-sb-text-condition-button>
                          <button type="button" class="info-button pt-1" [ngbPopover]="popInfoTemplate3" data-html="true"
                                  triggers="mouseenter:mouseleave" placement="auto" [container]="'body'"
                                  [popoverClass]="'info-popover'" (click)="applyRTLEmbedding(description, 'description')">
                            <i class="fa fa-paragraph"></i>
                          </button>
                          <ng-template #popInfoTemplate3>
                            <p class="mb-0">
                              Move the text cursor before the English word inside the RTL text and click the button.
                              This would make the RTL texts to show properly when they're mixed with LTR characters.
                            </p>
                          </ng-template>
                        </div>
                        <div class="widget-setting-description">Describe the campaign for social and link previews</div>
                        <div class='widget-setting-control input-group input-group-sm variable-textarea'>
                          <textarea class="form-control overflow-hidden auto-grow-textarea" #description
                                    (keyup)="updateValue($event, 'description')"
                                    [value]="campaignMeta.description"
                                    (input)="autoGrow(description)"
                                    [attr.maxlength]="getDescriptionMaxLength()"
                                    [class.over-limit]="isDescriptionOverLimit()"
                                    rows="5"></textarea>
                        </div>
                        <app-sb-text-condition-hint [text]="campaignMeta.description" [target]="description"
                                                    (applied)="updateValue({target: description}, 'description')"></app-sb-text-condition-hint>
                      </div>
                    </div>
                  </div>
                </div>
                <div class='row'>
                  <div class='col-md-11 mb-3 mx-auto'>
                    <div class="widget-setting-row widget-setting-field-row">
                      <div class="widget-setting-icon"><i class="fa fa-picture-o" aria-hidden="true"></i></div>
                      <div class="widget-setting-main">
                        <div class="widget-setting-title">Preview Media</div>
                        <div class="widget-setting-description">Choose the media and display order used for campaign previews</div>
                        <div class="widget-setting-control widget-media-control">
                          <div class="share-media-order-list">
                            <div class="share-media-order-control">
                              <label class="widget-media-setting-label" for="share_media_order">Media Order</label>
                              <select id="share_media_order"
                                      class="form-control form-control-sm"
                                      [ngModel]="shareMediaOrder[0]"
                                      [ngModelOptions]="{standalone: true}"
                                      (ngModelChange)="setShareMediaOrderFirst($event)">
                                <option value="video">Video first, then image</option>
                                <option value="image">Image first, then video</option>
                              </select>
                            </div>

                            <div class="share-media-order-section">
                              <div class="share-media-order-header">
                                <div>
                                  <div class="widget-setting-title">Preview Image</div>
                                  <div class="widget-setting-description">Suggested format: 1200x700px</div>
                                </div>
                              </div>
                              @if (getImage(); as previewImage) {
                                <div class="share-preview-media">
                                  @if (getPreviewMediaState('image', previewImage) !== 'error') {
                                  <img
                                       class="img-fluid rounded me-3 shadow-sm"
                                       [src]="previewImage" width="100%"
                                       height="100"
                                       (load)="onPreviewMediaLoaded('image', previewImage)"
                                       (error)="onPreviewMediaError('image', previewImage)"/>
                                  }
                                  @if (getPreviewMediaState('image', previewImage) === 'error' && !isPreviewImageGenerating()) {
                                  <div
                                       class="rounded border bg-white text-muted text-center p-4">
                                    The preview image could not be loaded.
                                  </div>
                                  }
                                  @if (isPreviewImageGenerating() || getPreviewMediaState('image', previewImage) === 'loading') {
                                  <div
                                       class="share-preview-media-loading" role="status">
                                    <span class="spinner-border text-secondary" aria-hidden="true"></span>
                                    <span>{{ isPreviewImageGenerating() ? 'Generating preview image...' : 'Loading preview image...' }}</span>
                                  </div>
                                  }
                                  <div class="share-video-preview-actions">
                                    <button type="button" class="btn btn-xs share-video-preview-action"
                                            (click)="removePreviewImage()">
                                      Remove Image
                                    </button>
                                  </div>
                                </div>
                              } @else {
                                @if (isPreviewImageGenerating()) {
                                <div
                                     class="share-preview-media share-preview-media-placeholder"
                                     [style.aspect-ratio]="getPreviewImageAspectRatio()">
                                  <div class="share-preview-media-loading" role="status">
                                    <span class="spinner-border text-secondary" aria-hidden="true"></span>
                                    <span>Generating preview image...</span>
                                  </div>
                                </div>
                                }
                                @if (!hasImageOrTemplate()) {
                                <div class="widget-setting-description">
                                  {{ hasSelectedOrSavedVideo() || usesPersonalizeTemplateVideo() ? 'No image: the share carries the video only.' : 'No image.' }}
                                </div>
                                }
                              }
                              @if (getCampaignImageInput(); as campaignImage) {
                              <div class="share-campaign-media-input">
                                <img class="share-campaign-media-input-preview rounded" [src]="campaignImage" alt=""/>
                                <div class="share-campaign-media-input-text">
                                  <div class="widget-setting-title">Campaign image</div>
                                  <div class="widget-setting-description">Shown in the image of the image design bound to #CampaignMetaImageUrl#.</div>
                                  <div class="share-campaign-media-input-actions">
                                    <button type="button" class="btn btn-xs btn-default" (click)="removeCampaignImage()">
                                      Remove Image
                                    </button>
                                    <button type="button" class="btn btn-xs btn-default" (click)="useUploadedImageInsteadOfTemplate()">
                                      Use instead of the template
                                    </button>
                                  </div>
                                </div>
                              </div>
                              }
                              @if (getCampaignMediaUnusedWarning('image'); as unusedImageWarning) {
                              <small
                                     class="d-block mt-2 share-video-preview-warning" role="status">
                                <i class="fa fa-exclamation-triangle me-1" aria-hidden="true"></i>{{ unusedImageWarning }}
                              </small>
                              }
                              <div class="share-image-buttons w-100 mt-3" #imageButtonsDiv>
                                <div class="d-flex">
                                  <button (click)="personalizeImage()" class="btn btn-default btn-sm" type="button">
                                    Personalize Image
                                  </button>
                                  <button type="button" class="btn btn-default btn-sm ms-2" placement="auto"
                                          popoverClass="custom-popover"
                                          [autoClose]="'outside'" #popupTemp="ngbPopover" [ngbPopover]="popTemplate"
                                          container="body">
                                    Upload Image
                                  </button>
                                  <ng-template #popTemplate>
                                    <div class="p-2">
                                      <div class="draggable" draggable="true">
                                        <strong>Drop image</strong>
                                        <br/>
                                        (Or click)
                                        <div class="file-input-div">
                                          <input type="file" accept="image/jpeg, image/jpg, image/png, image/gif, image/webp"
                                                 (change)="uploadTab = 'image';onSocialMediaImageSelect($event);popupTemp.close();"
                                                 tabindex="-1" role="button" dir="auto">
                                        </div>
                                      </div>
                                    </div>
                                  </ng-template>
                                </div>
                              </div>
                            </div>

                            <div class="share-media-order-section">
                              <div class="share-media-order-header">
                                <div>
                                  <div class="widget-setting-title">Preview Video</div>
                                </div>
                                <button type="button"
                                        class="meta-video-policy-trigger"
                                        aria-label="View Meta Video policy"
                                        [ngbPopover]="metaVideoPolicy"
                                        triggers="hover focus"
                                        placement="auto"
                                        container="body"
                                        popoverClass="meta-video-policy-popover">
                                  <span aria-hidden="true">?</span>
                                </button>
                                <ng-template #metaVideoPolicy>
                                  <section class="meta-video-policy" aria-label="Meta Video policy details">
                                    <div class="meta-video-policy-content">
                                      <table class="meta-video-policy-table">
                                        <caption>Recommended social-ready dimensions</caption>
                                        <thead>
                                          <tr>
                                            <th scope="col">Layout</th>
                                            <th scope="col">Ratio</th>
                                            <th scope="col">Recommended size</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>Landscape</td>
                                            <td>16:9</td>
                                            <td>1280×720–1920×1080</td>
                                          </tr>
                                          <tr>
                                            <td>Square</td>
                                            <td>1:1</td>
                                            <td>720×720–1920×1920</td>
                                          </tr>
                                          <tr>
                                            <td>Portrait</td>
                                            <td>4:5</td>
                                            <td>720×900–1080×1350</td>
                                          </tr>
                                          <tr>
                                            <td>Vertical</td>
                                            <td>9:16</td>
                                            <td>720×1280–1080×1920</td>
                                          </tr>
                                        </tbody>
                                      </table>

                                      <div class="meta-video-policy-requirements">
                                        <div>
                                          <span>Format</span>
                                          <strong>MP4 · H.264 + AAC</strong>
                                        </div>
                                        <div>
                                          <span>Duration</span>
                                          <strong>{{ videoUploadPolicy.minDurationSeconds }}–{{ videoUploadPolicy.maxDurationSeconds }} seconds</strong>
                                        </div>
                                        <div>
                                          <span>File size</span>
                                          <strong>300 MB maximum</strong>
                                        </div>
                                        <div>
                                          <span>Frame rate</span>
                                          <strong>{{ videoUploadPolicy.minFrameRate }}–{{ videoUploadPolicy.maxFrameRate }} FPS · 30 recommended</strong>
                                        </div>
                                        <div class="meta-video-policy-requirement-wide">
                                          <span>Accepted dimensions</span>
                                          <strong>{{ videoUploadPolicy.minWidth }}–{{ videoUploadPolicy.maxWidth }} px wide · {{ videoUploadPolicy.minHeight }}–{{ videoUploadPolicy.maxHeight }} px high</strong>
                                        </div>
                                        <div class="meta-video-policy-requirement-wide">
                                          <span>Accepted aspect ratio</span>
                                          <strong>9:16–1.91:1</strong>
                                        </div>
                                      </div>

                                      <div class="meta-video-policy-recommendation">
                                        <span><strong>Best:</strong> 1080×1920 at 30 FPS. A cover image is optional.</span>
                                      </div>
                                    </div>
                                  </section>
                                </ng-template>
                              </div>
                              @if (usesPersonalizeTemplateVideo()) {
                              @switch (getTemplateVideoPreviewStatus()) {
                                  @case ('ready') {
                                  <div class="share-video-preview">
                                    @if (getGeneratedTemplateVideoUrl(); as templateVideo) {
                                    <div class="share-preview-media">
                                      @if (getPreviewMediaState('video', templateVideo) !== 'error') {
                                      <video
                                             class="img-fluid rounded shadow-sm"
                                             [src]="templateVideo" width="100%" controls
                                             preload="metadata"
                                             [style.aspect-ratio]="getPreviewVideoAspectRatio(templateVideo, getTemplateVideoAspectRatio())"
                                             style="object-fit: contain; height: auto;"
                                             (loadedmetadata)="onPreviewVideoMetadata(templateVideo, $event)"
                                             (loadeddata)="onPreviewMediaLoaded('video', templateVideo)"
                                             (canplay)="onPreviewMediaLoaded('video', templateVideo)"
                                             (error)="onPreviewMediaError('video', templateVideo)"></video>
                                      }
                                      @if (getPreviewMediaState('video', templateVideo) === 'error') {
                                      <div
                                           class="rounded border bg-white text-muted text-center p-4">
                                        The preview video could not be loaded.
                                      </div>
                                      }
                                      @if (getPreviewMediaState('video', templateVideo) === 'loading') {
                                      <div
                                           class="share-preview-media-loading" role="status">
                                        <span class="spinner-border text-secondary" aria-hidden="true"></span>
                                        <span>Loading preview video...</span>
                                      </div>
                                      }
                                      <ng-container *ngTemplateOutlet="videoTemplateActions"></ng-container>
                                    </div>
                                    }
                                    @if (getTemplateVideoPreviewWarning(); as previewWarning) {
                                    <small
                                           class="d-block mt-2 share-video-preview-warning" role="status">
                                      <i class="fa fa-exclamation-triangle me-1" aria-hidden="true"></i>{{ previewWarning }}
                                    </small>
                                    }
                                    <small class="d-block mt-2 text-muted">
                                      Generated from the video design.@if (!getTemplateVideoPreviewWarning()) {

                                      @if (isInfluencerVideoUpdateEnabled()) { Each influencer gets their own, using the video they upload in the widget.} @else { Turn on Update Profile Video in Widget Settings to let influencers upload the video it plays.}
                                  }
                                    </small>
                                  </div>
                              }
                                  @case ('generating') {
                                  <div
                                       class="share-video-preview share-preview-media share-preview-media-placeholder"
                                       [style.aspect-ratio]="getTemplateVideoAspectRatio()">
                                    <div class="share-preview-media-loading" role="status">
                                      <span class="spinner-border text-secondary" aria-hidden="true"></span>
                                      <span>Generating preview video...</span>
                                    </div>
                                    <ng-container *ngTemplateOutlet="videoTemplateActions"></ng-container>
                                  </div>
                                  }
                                  @case ('delayed') {
                                  <div class="share-video-preview rounded border bg-white text-muted text-center p-4 pt-5">
                                    The preview video is taking longer than usual. It will appear here once it is ready.
                                    <ng-container *ngTemplateOutlet="videoTemplateActions"></ng-container>
                                  </div>
                                  }
                                }

                                <ng-template #videoTemplateActions>
                                  <div class="share-video-preview-actions">
                                    <button type="button" class="btn btn-xs share-video-preview-action"
                                            [disabled]="videoTemplateRequestPending"
                                            (click)="stopUsingVideoTemplate()">
                                      Remove Video
                                    </button>
                                  </div>
                                </ng-template>
                                @if (getCampaignVideoInput(); as campaignVideo) {
                                <div class="share-campaign-media-input">
                                  <video class="share-campaign-media-input-preview rounded" [src]="campaignVideo" [poster]="getVideoPoster()"
                                         preload="metadata" muted playsinline></video>
                                  <div class="share-campaign-media-input-text">
                                    <div class="widget-setting-title">Campaign video</div>
                                    <div class="widget-setting-description">Plays in the image of the video design bound to #CampaignMetaVideoUrl#.</div>
                                    <div class="share-campaign-media-input-actions">
                                      @if (hasVideoPoster()) {
                                      <button type="button" class="btn btn-xs btn-default" (click)="removeVideoPoster()">
                                        Remove Cover
                                      </button>
                                      }
                                      <button type="button" class="btn btn-xs btn-default" (click)="removeVideo()">
                                        Remove Video
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                }
                                @if (getCampaignMediaUnusedWarning('video'); as unusedVideoWarning) {
                                <small
                                       class="d-block mt-2 share-video-preview-warning" role="status">
                                  <i class="fa fa-exclamation-triangle me-1" aria-hidden="true"></i>{{ unusedVideoWarning }}
                                </small>
                                }
} @else {
                                @if (getVideoPreview(); as uploadedVideo) {
                                  <div class="share-video-preview share-preview-media">
                                    @if (getPreviewMediaState('video', uploadedVideo) !== 'error') {
                                    <video
                                           class="img-fluid rounded shadow-sm"
                                           [src]="uploadedVideo" [poster]="getVideoPoster()" width="100%" controls
                                           preload="metadata"
                                           [style.aspect-ratio]="getPreviewVideoAspectRatio(uploadedVideo, getVideoAspectRatio())"
                                           style="object-fit: contain; height: auto;"
                                           (loadedmetadata)="onPreviewVideoMetadata(uploadedVideo, $event)"
                                           (loadeddata)="onPreviewMediaLoaded('video', uploadedVideo)"
                                           (canplay)="onPreviewMediaLoaded('video', uploadedVideo)"
                                           (error)="onPreviewMediaError('video', uploadedVideo)"></video>
                                    }
                                    @if (getPreviewMediaState('video', uploadedVideo) === 'error') {
                                    <div
                                         class="rounded border bg-white text-muted text-center p-4">
                                      The video could not be loaded.
                                    </div>
                                    }
                                    @if (getPreviewMediaState('video', uploadedVideo) === 'loading') {
                                    <div
                                         class="share-preview-media-loading" role="status">
                                      <span class="spinner-border text-secondary" aria-hidden="true"></span>
                                      <span>Loading video...</span>
                                    </div>
                                    }
                                    <div class="share-video-preview-actions">
                                      @if (hasVideoPoster()) {
                                      <button type="button" class="btn btn-xs share-video-preview-action"
                                              (click)="removeVideoPoster()">
                                        Remove Cover
                                      </button>
                                      }
                                      <button type="button" class="btn btn-xs share-video-preview-action"
                                              (click)="removeVideo()">
                                        Remove Video
                                      </button>
                                    </div>
                                  </div>
                                } @else {
                                <div class="rounded border bg-white text-muted text-center p-4">
                                  No video uploaded yet.
                                </div>
                                }
}
                              @if (campaignMeta?.video_validation?.valid === false) {
                              <small class="d-block mt-2 text-danger">
                                {{ getVideoValidationErrorText() }}
                              </small>
                              }
                              @if (showShareVideoLength()) {
                              <div class="share-video-length mt-3">
                                <label class="widget-media-setting-label" for="share_video_duration">Share video length</label>
                                <div class="input-group input-group-sm share-video-length-input">
                                  <input id="share_video_duration" type="number" class="form-control" min="1"
                                         [max]="videoUploadPolicy.maxDurationSeconds" step="1"
                                         [placeholder]="getShareVideoLengthPlaceholder()"
                                         [ngModel]="$safeNavigationMigration(campaignMeta?.share_video_duration)"
                                         [ngModelOptions]="{standalone: true}"
                                         (ngModelChange)="setShareVideoDuration($event)">
                                  <span class="input-group-text">sec</span>
                                </div>
                                <small class="d-block mt-1 text-muted">
                                  How long each share video runs; empty is the campaign video's own length. The campaign
                                  video repeats to fill it, and an influencer's longer video is cut at it.
                                </small>
                              </div>
                              }
                              <div class="d-flex flex-wrap mt-3">
                                <app-sb-premium-lock class="d-inline-block" feature="Personalized video" [locked]="!currentUser?.can('use-personalized-video', 'campaign')">
                                  <button type="button"
                                          class="btn btn-default btn-sm me-2 mb-2"
                                          [disabled]="videoTemplateRequestPending"
                                          (click)="personalizeVideo()">
                                    Personalize Video
                                    <app-sb-premium-badge feature="Personalized video" [asLabel]="true"></app-sb-premium-badge>
                                  </button>
                                </app-sb-premium-lock>
                                <button type="button" class="btn btn-default btn-sm me-2 mb-2"
                                        (click)="uploadTab = 'video';videoUploadInput.value='';videoUploadInput.click();">
                                  Upload Video
                                </button>
                                @if (hasSelectedOrSavedVideo()) {
                                <button type="button" class="btn btn-default btn-sm me-2 mb-2"
                                        (click)="uploadTab = 'video_poster';videoCoverUploadInput.value='';videoCoverUploadInput.click();">
                                  Upload Video Cover (Optional)
                                </button>
                                }
                              </div>
                              <input #videoUploadInput class="d-none" type="file" accept="video/mp4"
                                     (change)="onSocialMediaImageSelect($event)"
                                     tabindex="-1" role="button" dir="auto">
                              <input #videoCoverUploadInput class="d-none" type="file"
                                     accept="image/jpeg, image/jpg, image/png, image/gif, image/webp"
                                     (change)="onSocialMediaImageSelect($event)"
                                     tabindex="-1" role="button" dir="auto">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="accordion" id="widgetSectionAccordion">
          <div class="card card-box">
            <div class='card-header py-0 pe-0 ps-3 header-color section-header-toggle' id='headingWidget'
                 (click)="sectionsStatus['widget'] = !sectionsStatus['widget']">
              <small class="section-header-title">
                Widget Settings
                <app-info-popover
                  class="section-header-help"
                  container="body"
                  (click)="$event.stopPropagation()"
                  info="Configure what influencers can do in the share widget for this campaign — editing primary info, updating picture or video, AI avatar, registration, launch state, and public access. Use Global keeps a setting in sync with the project default.">
                </app-info-popover>
              </small>
              <button class='btn btn-link ms-auto' type='button'
                      [attr.aria-expanded]="sectionsStatus['widget']" aria-controls='widgetSectionContainer'>
                <i class='fa fa-{{ !sectionsStatus["widget"] ? "plus" : "minus" }}'></i>
              </button>
            </div>
            <div class="pt-3 collapse modern-settings-section" id="widgetSectionContainer" aria-labelledby="headingWidget"
                 [class.show]="sectionsStatus['widget']">
              <div class="settings-group">
                <div class="row">
                  <div class='col-md-11 mx-auto'>
                    <div class='position-relative'>
                        <div>
                          <div class="widget-setting-row">
                            <div class="widget-setting-icon">
                              <i class="fa fa-pencil" aria-hidden="true"></i>
                            </div>
                            <div class="widget-setting-main">
                              <div class="widget-setting-title">Edit Primary Info</div>
                              <div class="widget-setting-description">Allow influencer to edit name, title, contact info</div>
                              <div class="widget-setting-meta">
                                <span>Global value: {{getCampaignWidgetGlobalValueLabel('allow_influencers_to_edit_primary_info')}}</span>
                              </div>
                            </div>
                            <div class="widget-setting-toggle-actions">
                              <button type="button"
                                      class="widget-use-global-button"
                                      [class.active]="isCampaignWidgetUsingGlobal('allow_influencers_to_edit_primary_info')"
                                      (click)="onCampaignWidgetUseGlobalChange('allow_influencers_to_edit_primary_info', !isCampaignWidgetUsingGlobal('allow_influencers_to_edit_primary_info'))">
                                <i class="fa fa-link" aria-hidden="true"></i>
                                <span>Use Global</span>
                              </button>
                              <label class="widget-toggle" for="allow_influencers_to_edit_primary_info">
                                <input id="allow_influencers_to_edit_primary_info"
                                       type="checkbox"
                                       [ngModel]="getCampaignWidgetSettingValue('allow_influencers_to_edit_primary_info')"
                                       (ngModelChange)="setCampaignWidgetSettingValue('allow_influencers_to_edit_primary_info', $event)"
                                       [disabled]="isCampaignWidgetUsingGlobal('allow_influencers_to_edit_primary_info')">
                                <span></span>
                              </label>
                            </div>
                          </div>

                          <div class="widget-setting-row">
                            <div class="widget-setting-icon">
                              <i class="fa fa-camera" aria-hidden="true"></i>
                            </div>
                            <div class="widget-setting-main">
                              <div class="widget-setting-title">Update Profile Picture</div>
                              <div class="widget-setting-description">Allow influencers to update their photo</div>
                              <div class="widget-setting-meta">
                                <span>Global value: {{getCampaignWidgetGlobalValueLabel('allow_influencers_to_update_their_picture_in_widget')}}</span>
                                <button type="button"
                                        class="widget-advanced-link"
                                        (click)="openWidgetAdvancedSettings(advancedImageSettingsModal)">
                                  Advanced Settings
                                </button>
                              </div>
                            </div>
                            <div class="widget-setting-toggle-actions">
                              <button type="button"
                                      class="widget-use-global-button"
                                      [class.active]="isCampaignWidgetUsingGlobal('allow_influencers_to_update_their_picture_in_widget')"
                                      (click)="onCampaignWidgetUseGlobalChange('allow_influencers_to_update_their_picture_in_widget', !isCampaignWidgetUsingGlobal('allow_influencers_to_update_their_picture_in_widget'))">
                                <i class="fa fa-link" aria-hidden="true"></i>
                                <span>Use Global</span>
                              </button>
                              <label class="widget-toggle" for="allow_influencers_to_update_their_picture_in_widget">
                                <input id="allow_influencers_to_update_their_picture_in_widget"
                                       type="checkbox"
                                       [ngModel]="getCampaignWidgetSettingValue('allow_influencers_to_update_their_picture_in_widget')"
                                       (ngModelChange)="setCampaignWidgetSettingValue('allow_influencers_to_update_their_picture_in_widget', $event)"
                                       [disabled]="isCampaignWidgetUsingGlobal('allow_influencers_to_update_their_picture_in_widget')">
                                <span></span>
                              </label>
                            </div>
                          </div>

                          <app-sb-premium-lock feature="Influencer video upload" [locked]="!currentUser?.can('unrestricted-use-video-upload', 'project')">
                            <div class="widget-setting-row">
                              <div class="widget-setting-icon">
                                <i class="fa fa-video-camera" aria-hidden="true"></i>
                              </div>
                              <div class="widget-setting-main">
                                <div class="widget-setting-title">Update Profile Video<app-sb-premium-badge feature="Influencer video upload"></app-sb-premium-badge></div>
                                <div class="widget-setting-description">Allow influencers to update their video</div>
                                <div class="widget-setting-meta">
                                  <span>Global value: {{getCampaignWidgetGlobalValueLabel('allow_influencers_to_update_their_video_in_widget')}}</span>
                                  <button type="button"
                                          class="widget-advanced-link"
                                          (click)="openWidgetAdvancedSettings(advancedVideoSettingsModal)">
                                    Advanced Settings
                                  </button>
                                </div>
                              </div>
                              <div class="widget-setting-toggle-actions">
                                <button type="button"
                                        class="widget-use-global-button"
                                        [class.active]="isCampaignWidgetUsingGlobal('allow_influencers_to_update_their_video_in_widget')"
                                        (click)="onCampaignWidgetUseGlobalChange('allow_influencers_to_update_their_video_in_widget', !isCampaignWidgetUsingGlobal('allow_influencers_to_update_their_video_in_widget'))">
                                  <i class="fa fa-link" aria-hidden="true"></i>
                                  <span>Use Global</span>
                                </button>
                                <label class="widget-toggle" for="allow_influencers_to_update_their_video_in_widget">
                                  <input id="allow_influencers_to_update_their_video_in_widget"
                                         type="checkbox"
                                         [ngModel]="getCampaignWidgetSettingValue('allow_influencers_to_update_their_video_in_widget')"
                                         (ngModelChange)="setCampaignWidgetSettingValue('allow_influencers_to_update_their_video_in_widget', $event)"
                                         [disabled]="isCampaignWidgetUsingGlobal('allow_influencers_to_update_their_video_in_widget')">
                                  <span></span>
                                </label>
                              </div>
                            </div>
                          </app-sb-premium-lock>

                          <app-sb-premium-lock feature="AI Avatar" [locked]="!currentUser?.can('unrestricted-use-ai-avatar', 'project')">
                            <div class="widget-setting-row">
                              <div class="widget-setting-icon">
                                <i class="fa fa-star-o" aria-hidden="true"></i>
                              </div>
                              <div class="widget-setting-main">
                                <div class="widget-setting-title">AI Avatar Generation<app-sb-premium-badge feature="AI Avatar"></app-sb-premium-badge></div>
                                <div class="widget-setting-description">Allow AI-generated avatar images</div>
                                <div class="widget-setting-meta">
                                  <span>Global value: {{getCampaignWidgetGlobalValueLabel('allow_influencers_to_use_ai_avatar_in_widget')}}</span>
                                </div>
                              </div>
                              <div class="widget-setting-toggle-actions">
                                <button type="button"
                                        class="widget-use-global-button"
                                        [class.active]="isCampaignWidgetUsingGlobal('allow_influencers_to_use_ai_avatar_in_widget')"
                                        (click)="onCampaignWidgetUseGlobalChange('allow_influencers_to_use_ai_avatar_in_widget', !isCampaignWidgetUsingGlobal('allow_influencers_to_use_ai_avatar_in_widget'))">
                                  <i class="fa fa-link" aria-hidden="true"></i>
                                  <span>Use Global</span>
                                </button>
                                <label class="widget-toggle" for="allow_influencers_to_use_ai_avatar_in_widget">
                                  <input id="allow_influencers_to_use_ai_avatar_in_widget"
                                         type="checkbox"
                                         [ngModel]="getCampaignWidgetSettingValue('allow_influencers_to_use_ai_avatar_in_widget')"
                                         (ngModelChange)="setCampaignWidgetSettingValue('allow_influencers_to_use_ai_avatar_in_widget', $event)"
                                         [disabled]="isCampaignWidgetUsingGlobal('allow_influencers_to_use_ai_avatar_in_widget') || !getCampaignWidgetSettingValue('allow_influencers_to_update_their_picture_in_widget')">
                                  <span></span>
                                </label>
                              </div>
                            </div>

                            <div class="widget-avatar-template-section widget-sub-setting mb-3">
                              <div class="widget-avatar-template-controls">
                                <app-sb-input-select
                                  [id]="'campaign_widget_ai_avatar_template'"
                                  class="widget-avatar-template-select"
                                  label="AI Avatar Template"
                                  placeholder="Select Widget AI Avatar Template"
                                  imageKey="selectedImageVariation.url"
                                  [items]="widgetAIAvatarTemplates"
                                  [clearable]="false"
                                  [disabled]="!getCampaignWidgetSettingValue('allow_influencers_to_use_ai_avatar_in_widget') || widgetAIAvatarTemplates.length <= 0"
                                  [ngModel]="campaignMeta['widget_ai_avatar_template'] || null"
                                  (ngModelChange)="selectWidgetAIAvatarTemplate($event)">
                                </app-sb-input-select>
                                <button class="btn widget-customize-btn"
                                        type="button"
                                        role="button"
                                        (click)="showCustomizeAvatarTemplatePopup()"
                                        [disabled]="!getCampaignWidgetSettingValue('allow_influencers_to_use_ai_avatar_in_widget')">
                                  Customize
                                </button>
                              </div>
                            </div>
                          </app-sb-premium-lock>
                        </div>
                          <div class="widget-setting-row">
                            <div class="widget-setting-icon">
                              <i class="fa fa-rocket" aria-hidden="true"></i>
                            </div>
                            <div class="widget-setting-main">
                              <div class="widget-setting-title">Launch Without Active Registration Widget</div>
                              <div class="widget-setting-description">Allow the campaign to launch when the registration widget is not active</div>
                            </div>
                            <label class="widget-toggle" for="campaign_registration_widget">
                              <input id="campaign_registration_widget"
                                     type="checkbox"
                                     [(ngModel)]="campaignMeta['allow_campaign_to_launch_when_registration_widget_is_disabled']"
                                     (ngModelChange)="onSettingsChange($event)">
                              <span></span>
                            </label>
                          </div>

                          <div class="widget-setting-row">
                            <div class="widget-setting-icon">
                              <i class="fa fa-exchange" aria-hidden="true"></i>
                            </div>
                            <div class="widget-setting-main">
                              <div class="widget-setting-title">Switch Widget on Launch</div>
                              <div class="widget-setting-description">Switch the widget to this campaign when the campaign launch starts</div>
                            </div>
                            <label class="widget-toggle" for="switch_widget_launched">
                              <input id="switch_widget_launched"
                                     type="checkbox"
                                     [(ngModel)]="campaignMeta['switch_widget_to_this_campaign_when_launched']"
                                     (ngModelChange)="onSettingsChange($event)">
                              <span></span>
                            </label>
                          </div>

                          <div class="widget-setting-row">
                            <div class="widget-setting-icon">
                              <i class="fa fa-users" aria-hidden="true"></i>
                            </div>
                            <div class="widget-setting-main">
                              <div class="widget-setting-title">Generic Widget</div>
                              <div class="widget-setting-description">Allow users to join through the widget, receive a personalized link, and start sharing</div>
                            </div>
                            <label class="widget-toggle" for="public_widget_enabled">
                              <input id="public_widget_enabled"
                                     type="checkbox"
                                     [(ngModel)]="campaignMeta['public_widget_enabled']"
                                     (ngModelChange)="onSettingsChange($event)">
                              <span></span>
                            </label>
                          </div>

                          <ng-template #campaignWidgetUseGlobal let-key="key">
                            <button type="button"
                                    class="widget-use-global-button widget-field-use-global-button"
                                    [class.active]="isCampaignWidgetUsingGlobal(key)"
                                    [attr.aria-pressed]="isCampaignWidgetUsingGlobal(key)"
                                    (click)="onCampaignWidgetUseGlobalChange(key, !isCampaignWidgetUsingGlobal(key))">
                              <i class="fa fa-link" aria-hidden="true"></i>
                              <span>Use Global</span>
                            </button>
                          </ng-template>

                          <div class="widget-setting-row widget-setting-field-row">
                            <div class="widget-setting-icon">
                              <i class="fa fa-language" aria-hidden="true"></i>
                            </div>
                            <div class="widget-setting-main">
                              <div class="widget-setting-title-row">
                                <div class="widget-setting-title">Widget Language</div>
                                <ng-container
                                  *ngTemplateOutlet="campaignWidgetUseGlobal; context: {key: 'widget_language'}">
                                </ng-container>
                              </div>
                              <div class="widget-setting-description">Choose the language used in the campaign widget</div>
                              <div class="widget-setting-control">
                                <app-sb-input-language
                                  [ngModel]="getCampaignWidgetFieldValue('widget_language')"
                                  (ngModelChange)="onCampaignWidgetFieldChange('widget_language', $event)"
                                  [disabled]="isCampaignWidgetUsingGlobal('widget_language')"
                                  id="campaign_widget_language"
                                  placeholder="Select language"
                                  label="">
                                </app-sb-input-language>
                              </div>
                            </div>
                          </div>

                          <div class="widget-setting-row widget-setting-field-row">
                            <div class="widget-setting-icon">
                              <i class="fa fa-header" aria-hidden="true"></i>
                            </div>
                            <div class="widget-setting-main">
                              <div class="widget-setting-title-row">
                                <div class="widget-setting-title">Header 1</div>
                                <app-variables (onVariableForClick)="onMetaVariablesButtonClick($event)"
                                               [isDisabled]="isCampaignWidgetUsingGlobal('widget_header_1')"
                                               [variableClickFor]="'widget_header_1'"
                                               (onVariableClick)="onWidgetTextEditorVariableClick($event, 'widget_header_1', widgetHeader1Editor)">
                                </app-variables>
                                <ng-container
                                  *ngTemplateOutlet="campaignWidgetUseGlobal; context: {key: 'widget_header_1'}">
                                </ng-container>
                              </div>
                              <div class="widget-setting-description">{{ widgetHeaderDescriptions.header_1 }}</div>
                              <div class="widget-setting-control">
                                <app-sb-rich-text
                                  #widgetHeader1Editor
                                  class="share-widget-text-editor share-widget-text-editor-compact"
                                  [tools]="getWidgetTextEditorConfig('widget_header_1').tools"
                                  [height]="getWidgetTextEditorConfig('widget_header_1').height"
                                  [multiline]="getWidgetTextEditorConfig('widget_header_1').multiline"
                                  [html]="getWidgetTextEditorData('widget_header_1')"
                                  [placeholder]="getWidgetHeaderPlaceholder('widget_header_1')"
                                  [readOnly]="isCampaignWidgetUsingGlobal('widget_header_1')"
                                  (htmlChange)="onWidgetTextEditorChange('widget_header_1', $event, widgetHeader1Editor)"
                                  shape="inline"
                                  [inlineStyles]="true"
                                  [linkUnderlineToggle]="true"
                                  [autoGrow]="true"
                                  [resizable]="true">
                                </app-sb-rich-text>
                                @if (getWidgetHeaderNotLiveNote('widget_header_1'); as note) {
                                <div class="widget-setting-description widget-header-not-live-note">
                                  {{ note.label }} @if (note.text) {<span [innerHTML]="note.text"></span>}
                                </div>
                                }
                              </div>
                            </div>
                          </div>

                          <div class="widget-setting-row widget-setting-field-row">
                            <div class="widget-setting-icon">
                              <i class="fa fa-header" aria-hidden="true"></i>
                            </div>
                            <div class="widget-setting-main">
                              <div class="widget-setting-title-row">
                                <div class="widget-setting-title">Header 2</div>
                                <app-variables (onVariableForClick)="onMetaVariablesButtonClick($event)"
                                               [isDisabled]="isCampaignWidgetUsingGlobal('widget_header_2')"
                                               [variableClickFor]="'widget_header_2'"
                                               (onVariableClick)="onWidgetTextEditorVariableClick($event, 'widget_header_2', widgetHeader2Editor)">
                                </app-variables>
                                <ng-container
                                  *ngTemplateOutlet="campaignWidgetUseGlobal; context: {key: 'widget_header_2'}">
                                </ng-container>
                              </div>
                              <div class="widget-setting-description">{{ widgetHeaderDescriptions.header_2 }}</div>
                              <div class="widget-setting-control">
                                <app-sb-rich-text
                                  #widgetHeader2Editor
                                  class="share-widget-text-editor share-widget-text-editor-compact"
                                  [tools]="getWidgetTextEditorConfig('widget_header_2').tools"
                                  [height]="getWidgetTextEditorConfig('widget_header_2').height"
                                  [multiline]="getWidgetTextEditorConfig('widget_header_2').multiline"
                                  [html]="getWidgetTextEditorData('widget_header_2')"
                                  [placeholder]="getWidgetHeaderPlaceholder('widget_header_2')"
                                  [readOnly]="isCampaignWidgetUsingGlobal('widget_header_2')"
                                  (htmlChange)="onWidgetTextEditorChange('widget_header_2', $event, widgetHeader2Editor)"
                                  shape="inline"
                                  [inlineStyles]="true"
                                  [linkUnderlineToggle]="true"
                                  [autoGrow]="true"
                                  [resizable]="true">
                                </app-sb-rich-text>
                                @if (getWidgetHeaderNotLiveNote('widget_header_2'); as note) {
                                <div class="widget-setting-description widget-header-not-live-note">
                                  {{ note.label }} @if (note.text) {<span [innerHTML]="note.text"></span>}
                                </div>
                                }
                              </div>
                            </div>
                          </div>

                          <div class="widget-setting-row widget-setting-field-row">
                            <div class="widget-setting-icon">
                              <i class="fa fa-header" aria-hidden="true"></i>
                            </div>
                            <div class="widget-setting-main">
                              <div class="widget-setting-title-row">
                                <div class="widget-setting-title">Header 3</div>
                                <app-variables (onVariableForClick)="onMetaVariablesButtonClick($event)"
                                               [isDisabled]="isCampaignWidgetUsingGlobal('widget_header_3')"
                                               [variableClickFor]="'widget_header_3'"
                                               (onVariableClick)="onWidgetTextEditorVariableClick($event, 'widget_header_3', widgetHeader3Editor)">
                                </app-variables>
                                <ng-container
                                  *ngTemplateOutlet="campaignWidgetUseGlobal; context: {key: 'widget_header_3'}">
                                </ng-container>
                              </div>
                              <div class="widget-setting-description">{{ widgetHeaderDescriptions.header_3 }}</div>
                              <div class="widget-setting-control">
                                <app-sb-rich-text
                                  #widgetHeader3Editor
                                  class="share-widget-text-editor share-widget-text-editor-compact"
                                  [tools]="getWidgetTextEditorConfig('widget_header_3').tools"
                                  [height]="getWidgetTextEditorConfig('widget_header_3').height"
                                  [multiline]="getWidgetTextEditorConfig('widget_header_3').multiline"
                                  [html]="getWidgetTextEditorData('widget_header_3')"
                                  [placeholder]="getWidgetHeaderPlaceholder('widget_header_3')"
                                  [readOnly]="isCampaignWidgetUsingGlobal('widget_header_3')"
                                  (htmlChange)="onWidgetTextEditorChange('widget_header_3', $event, widgetHeader3Editor)"
                                  shape="inline"
                                  [inlineStyles]="true"
                                  [linkUnderlineToggle]="true"
                                  [autoGrow]="true"
                                  [resizable]="true">
                                </app-sb-rich-text>
                                @if (getWidgetHeaderNotLiveNote('widget_header_3'); as note) {
                                <div class="widget-setting-description widget-header-not-live-note">
                                  {{ note.label }} @if (note.text) {<span [innerHTML]="note.text"></span>}
                                </div>
                                }
                              </div>
                            </div>
                          </div>

                          <div class="widget-setting-row widget-setting-field-row">
                            <div class="widget-setting-icon">
                              <i class="fa fa-comment-o" aria-hidden="true"></i>
                            </div>
                            <div class="widget-setting-main">
                              <div class="widget-setting-title-row">
                                <div class="widget-setting-title">Custom Minimized Text</div>
                                <ng-container
                                  *ngTemplateOutlet="campaignWidgetUseGlobal; context: {key: 'widget_open_message_text'}">
                                </ng-container>
                              </div>
                              <div class="widget-setting-description">Set the message shown while the widget is minimized</div>
                              <div class="widget-setting-control">
                                <input class="form-control form-control-sm" type="text"
                                       [ngModel]="getCampaignWidgetFieldValue('widget_open_message_text')"
                                       (ngModelChange)="onCampaignWidgetFieldChange('widget_open_message_text', $event || null)"
                                       [disabled]="isCampaignWidgetUsingGlobal('widget_open_message_text')"
                                       [placeholder]="widget_Settings?.open_message_text || 'Invite someone!'">
                              </div>
                            </div>
                          </div>

                          <div class="widget-setting-row widget-setting-field-row">
                            <div class="widget-setting-icon">
                              <i class="fa fa-bullhorn" aria-hidden="true"></i>
                            </div>
                            <div class="widget-setting-main">
                              <div class="widget-setting-title-row">
                                <div class="widget-setting-title">Promo Text</div>
                                <ng-container
                                  *ngTemplateOutlet="campaignWidgetUseGlobal; context: {key: 'widget_promo_text'}">
                                </ng-container>
                              </div>
                              <div class="widget-setting-description">Add promotional or offer text to the widget's left panel</div>
                              <div class="widget-setting-control">
                                <app-sb-rich-text
                                  #widgetPromoTextEditor
                                  class="share-widget-text-editor"
                                  [tools]="getWidgetTextEditorConfig('widget_promo_text').tools"
                                  [height]="getWidgetTextEditorConfig('widget_promo_text').height"
                                  [multiline]="getWidgetTextEditorConfig('widget_promo_text').multiline"
                                  [html]="getWidgetTextEditorData('widget_promo_text')"
                                  [readOnly]="isCampaignWidgetUsingGlobal('widget_promo_text')"
                                  (htmlChange)="onWidgetTextEditorChange('widget_promo_text', $event, widgetPromoTextEditor)"
                                  shape="inline"
                                  [inlineStyles]="true"
                                  [linkUnderlineToggle]="true"
                                  [autoGrow]="true"
                                  [resizable]="true">
                                </app-sb-rich-text>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        <app-sb-premium-lock feature="Snoflex - Advanced Widget" [locked]="!currentUser?.can('updateActionOrFieldSettings', 'campaign')">
        <div class="accordion" id="widgetActionButtonsSectionAccordion">
          <div class="card card-box">
            <div class='card-header py-0 pe-0 ps-3 header-color' id='headingWidget'>
              <small class="section-header-title">
                Snoflex - Advanced Widget<app-sb-premium-badge feature="Snoflex - Advanced Widget"></app-sb-premium-badge>
                <button type="button" class="section-header-expand"
                        title="Open in a larger window" aria-label="Open in a larger window"
                        (click)="$event.stopPropagation(); openSectionInModal('action_buttons', snoflexSectionModal)">
                  <i class="fa fa-external-link" aria-hidden="true"></i>
                </button>
                <app-info-popover
                  class="section-header-help"
                  container="body"
                  info="Enable Snoflex action buttons in the advanced widget. Define named actions with titles and icons, optionally require a choice before continuing, and link actions to custom influencer fields. Use the header switch to turn the feature on or off for this campaign.">
                </app-info-popover>
              </small>
              <label class="widget-toggle header-section-toggle ms-auto" for="action_buttons_active" (click)="$event.stopPropagation()">
                <input id="action_buttons_active"
                       placeholder="" type="checkbox"
                       [ngModel]="campaignMeta['action_buttons_active']"
                       (ngModelChange)="onActionButtonsActiveChange($event)">
                <span></span>
              </label>
              <button class='btn btn-link' type='button'
                      [attr.aria-expanded]="isSectionExpanded('action_buttons')"
                      aria-controls="widgetActionButtonsSectionContainer"
                      (click)="onActionButtonsActiveChange(!campaignMeta['action_buttons_active'])">
                <i class='fa fa-{{ isSectionExpanded("action_buttons") ? "minus" : "plus" }}'></i>
              </button>
            </div>
            <div class="pt-3 collapse modern-settings-section" id="widgetActionButtonsSectionContainer"
                 [class.show]="isSectionExpanded('action_buttons')"
                 aria-labelledby="headingWidget">
              @if (expandedSectionKey !== 'action_buttons') {
              <ng-container [ngTemplateOutlet]="snoflexSectionBody"></ng-container>
              }
            </div>
          </div>
        </div>
        </app-sb-premium-lock>

        <app-sb-premium-lock feature="Custom influencer fields" [locked]="!currentUser?.can('updateActionOrFieldSettings', 'campaign')">
          <div class="accordion" id="customFieldsAccordion">
            <div class="card card-box">
              <div class="card-header py-0 pe-0 ps-3 header-color" id="headingCustomFields">
                <small class="section-header-title">
                  Customize Influencer Fields<app-sb-premium-badge feature="Custom influencer fields"></app-sb-premium-badge>
                  <button type="button" class="section-header-expand"
                          title="Open in a larger window" aria-label="Open in a larger window"
                          (click)="$event.stopPropagation(); openSectionInModal('custom_fields', influencerFieldsSectionModal)">
                    <i class="fa fa-external-link" aria-hidden="true"></i>
                  </button>
                  <app-info-popover
                    class="section-header-help"
                    container="body"
                    info="Choose which influencer fields appear in the widget, group them into tabs, and set labels, types, read-only or required flags, and default values. Use the header switch to enable or disable custom fields for this campaign.">
                  </app-info-popover>
                </small>
                <label class="widget-toggle header-section-toggle ms-auto" for="influencer_fields_active" (click)="$event.stopPropagation()">
                  <input id="influencer_fields_active"
                         placeholder="" type="checkbox"
                         [ngModel]="campaignMeta['influencer_fields_active']"
                         (ngModelChange)="onInfluencerFieldsActiveChange($event)">
                  <span></span>
                </label>
                <button class="btn btn-link" type="button"
                        [attr.aria-expanded]="isSectionExpanded('custom_fields')"
                        aria-controls="customFieldsSectionContainer"
                        (click)="onInfluencerFieldsActiveChange(!campaignMeta['influencer_fields_active'])">
                  <i class="fa fa-{{ isSectionExpanded('custom_fields') ? 'minus' : 'plus' }}"></i>
                </button>
              </div>
              <div class="collapse influencer-fields-tab-content modern-settings-section" id="customFieldsSectionContainer"
                   [class.show]="isSectionExpanded('custom_fields')"
                   aria-labelledby="headingCustomFields">
                @if (expandedSectionKey !== 'custom_fields') {
                <ng-container [ngTemplateOutlet]="influencerFieldsSectionBody"></ng-container>
                }
              </div>
            </div>
          </div>
        </app-sb-premium-lock>
      </div>
    </div>
  </div>
</div>

<ng-template #snoflexSectionBody>
              <div class="settings-group advanced-widget-settings" style="min-width: 20rem;" cdkDropList (cdkDropListDropped)="dropActionButton($event)">

                    <div class="widget-setting-row">
                      <div class="widget-setting-icon"><i class="fa fa-check-square-o" aria-hidden="true"></i></div>
                      <div class="widget-setting-main">
                        <div class="widget-setting-title">Required Action</div>
                        <div class="widget-setting-description">Require users to choose an action before continuing</div>
                      </div>
                      <label class="widget-toggle" for="action_buttons_required">
                        <input id="action_buttons_required"
                               placeholder="" type="checkbox"
                               [(ngModel)]="campaignMeta['action_buttons_required']"
                               (ngModelChange)="onSettingsChange($event)">
                        <span></span>
                      </label>
                    </div>

                    @if (campaignMeta['action_buttons_active'] && campaignMeta['action_buttons_required']) {
                    <div
                      class="widget-setting-row widget-setting-field-row">
                      <div class="widget-setting-icon">
                        <i class="fa fa-commenting-o" aria-hidden="true"></i>
                      </div>
                      <div class="widget-setting-main">
                        <div class="widget-setting-title">No Action Message</div>
                        <div class="widget-setting-description">
                          Shown until a required action is selected. Leave empty to use the translated default.
                        </div>
                        <div class="widget-setting-control">
                          <app-sb-rich-text
                            #actionButtonsNoActionMessageEditor
                            class="share-widget-text-editor"
                            [tools]="getWidgetTextEditorConfig('action_buttons_no_action_message').tools"
                            [height]="getWidgetTextEditorConfig('action_buttons_no_action_message').height"
                            [multiline]="getWidgetTextEditorConfig('action_buttons_no_action_message').multiline"
                            [html]="getWidgetTextEditorData('action_buttons_no_action_message')"
                            (htmlChange)="onWidgetTextEditorChange('action_buttons_no_action_message', $event, actionButtonsNoActionMessageEditor)"
                            shape="inline"
                            [inlineStyles]="true"
                            [linkUnderlineToggle]="true"
                            [autoGrow]="true"
                            [resizable]="true">
                          </app-sb-rich-text>
                        </div>
                      </div>
                    </div>
                    }

                    @for (button of campaignMeta.action_buttons; track button; let i = $index) {
                    <div class="mt-4 mb-4 action-button-container" cdkDrag [cdkDragDisabled]="!campaignMeta['action_buttons_active']">
                      <div class="d-flex align-items-center">

                        <div class="d-flex align-items-center" cdkDragHandle>
                          <span class="material-icons text-muted" style="cursor: grab; font-size: 24px;">
                            drag_indicator
                          </span>
                        </div>

                        <div>
                          @if (campaignMeta.action_buttons.length > 1) {
                          <button
                            class="btn btn-sm rounded-circle me-2 text-white my-0 ms-0 p-0 d-flex align-items-center justify-content-center remove-button"
                            type="button"
                            [disabled]="!campaignMeta['action_buttons_active']"
                            (click)="removeActionButton(i)"
                          >
                            <span class="btn-wrapper--icon"><i class="fa fa-minus"></i></span>
                          </button>
                          }
                        </div>

                        <div class="flex-fill d-flex">
                          @if (!campaignMeta.action_buttons_required) {
                          <div class='input-group-sm variable-input me-2 custom-field-label'>
                            <input type="radio" name="defaultAction" [(ngModel)]="campaignMeta.default_action_button_index" (ngModelChange)="onSettingsChange($event)" [value]="i" [disabled]="!campaignMeta['action_buttons_active']" class="me-2">Default
                          </div>
                          }
                          <div class='flex-fill input-group-sm variable-input action-button-input'>
                            <input class="form-control me-2" type="text" [(ngModel)]="button.name" (ngModelChange)="onSettingsChange($event)" [disabled]="!campaignMeta['action_buttons_active']" placeholder="Name" [attr.title]="button.name || null" />
                          </div>
                          <div class='flex-fill input-group-sm variable-input action-button-input'>
                            <input type="text" [(ngModel)]="button.title" placeholder="Title" (ngModelChange)="onSettingsChange($event)" [disabled]="!campaignMeta['action_buttons_active']" class="form-control me-2" [attr.title]="button.title || null" />
                          </div>
                        </div>

                        <div class="me-2">
                          <app-file-browser [clientId]="$safeNavigationMigration(campaign?.client_id)" [projectId]="$safeNavigationMigration(campaign?.project_id)" [selectedImage]="button.icon" [enableChoose]="true" defaultIcon="fa fa-image" imageWidth="30px" imageHeight="30px" (fileSelected)="onActionButtonIconSelected($event, button)" class="me-2" [disabled]="!campaignMeta['action_buttons_active']"></app-file-browser>
                        </div>

                        <div>
                          <button
                            class="btn btn-sm rounded-circle me-2 text-white my-0 ms-0 p-0 d-flex align-items-center justify-content-center add-button"
                            type="button"
                            (click)="addActionButton(i)"
                            [disabled]="!campaignMeta['action_buttons_active']"
                          >
                            <span class="btn-wrapper--icon"><i class="fa fa-plus"></i></span>
                          </button>
                        </div>

                      </div>

                      @for (action of button.actions; track action; let j = $index) {
                      <div class="ms-4 mt-2">
                        <div class="d-flex">
                          <div>
                            @if (button.actions.length > 1) {
                            <button
                              class="btn btn-sm rounded-circle me-2 text-white my-0 ms-0 p-0 d-flex align-items-center justify-content-center remove-button"
                              type="button"
                              (click)="removeAction(button, j)"
                              [disabled]="!campaignMeta['action_buttons_active']"
                            >
                              <span class="btn-wrapper--icon"><i class="fa fa-minus"></i></span>
                            </button>
                            }
                          </div>

                          <div class="d-flex flex-grow-1">

                          <div class='flex-fill input-group-sm variable-input action-button-input'>
                            <select [ngModel]="getActionEditorType(action)" (ngModelChange)="onActionTypeChange(action, button, $event); onSettingsChange($event)" class="form-control me-2" [disabled]="!campaignMeta['action_buttons_active']">
                              <option [disabled]="isActionTypeAdded(button, 'set_segment') && action.type !== 'set_segment'" value="set_segment">Set Segment</option>
                              <option value="set_custom_field">Set Custom Field</option>
                              <option value="set_widget_settings">Set Widget Settings</option>
                              <option value="set_meta_media"
                                      [disabled]="getUsedMetaMediaSettingKeys(button).length === metaMediaSettingKeys.length && getActionEditorType(action) !== 'set_meta_media'">
                                Set Meta Media
                              </option>
                            </select>
                          </div>

                          <!-- set_segment -->
                          @if (action.type === 'set_segment') {
                          <div class="d-flex flex-fill">
                            <div class='flex-fill input-group-sm variable-input action-button-input'>
                              <select [(ngModel)]="action.influencerTypeId" (ngModelChange)="onSettingsChange($event)" class="form-control me-2" [disabled]="!campaignMeta['action_buttons_active']">
                                @for (type of filteredInfluencerTypes; track type) {
                                <option [value]="type.id">{{ type.name }}</option>
                                }
                              </select>
                            </div>
                            <div class='flex-fill input-group-sm variable-input action-button-input'>
                              <select [(ngModel)]="action.segmentId" (ngModelChange)="onSettingsChange($event)" class="form-control me-2" [disabled]="!campaignMeta['action_buttons_active']">
                                @for (segment of getInfluencerTypeSegments(action.influencerTypeId); track segment) {
                                <option [value]="segment.id">{{ segment.name }}</option>
                                }
                              </select>
                            </div>
                          </div>
                          }

                          <!-- set_campaign -->
                          @if (action.type === 'set_campaign') {
                            <div class='flex-fill input-group-sm variable-input action-button-input'>
                              <select [(ngModel)]="action.campaignId" (ngModelChange)="onSettingsChange($event)" class="form-control me-2" [disabled]="!campaignMeta['action_buttons_active']">
                                @for (c of campaigns; track c) {
                                <option [value]="c.id">{{ c.name }}</option>
                                }
                              </select>
                            </div>
                          }

                          <!-- set_custom_field -->
                          @if (action.type === 'set_custom_field') {
                            <div class='flex-fill input-group-sm variable-input action-button-input'>
                              <select [(ngModel)]="action.customField" (ngModelChange)="onSettingsChange($event)" class="form-control me-2" [disabled]="!campaignMeta['action_buttons_active']">
                                @for (f of getCustomFields(); track f) {
                                <option [value]="f.key"
                                        [disabled]="(getUsedCustomFields(button).includes(f.key) && action.customField !== f.key)">
                                  {{ f.label }}
                                </option>
                                }
                              </select>
                            </div>
                            <div class='flex-fill input-group-sm variable-input action-button-input'>
                              @if (getCustomField(action.customField)?.type === 'text' || getCustomField(action.customField)?.type === 'email') {
                                <input #customFieldInput type="text" [(ngModel)]="action.value" (ngModelChange)="onSettingsChange($event)" [disabled]="!campaignMeta['action_buttons_active']" placeholder="Value" class="form-control me-2" [attr.title]="action.value || null" />
                                <app-variables [variableClickFor]="'action_text_' + i + '_' + j"
                                              (onVariableClick)="onVariableClickForActionTriggerCustomFields($event, button, action, customFieldInput)"
                                              class="me-2"></app-variables>
                              }

                              @if (getCustomField(action.customField)?.type === 'text-multi-line') {
                                <textarea [(ngModel)]="action.value"
                                          (ngModelChange)="onSettingsChange($event)"
                                          class="form-control"
                                          placeholder="Value"
                                          rows="1"
                                          style="overflow:hidden; resize:none"
                                          [appAutoGrow]="action.value"
                                          [disabled]="!campaignMeta['action_buttons_active']"
                                          #actionCustomFieldValueTextArea></textarea>

                                <app-variables [variableClickFor]="'action_multiline_' + i + '_' + j"
                                              (onVariableClick)="onVariableClickForActionTriggerCustomFields($event, button, action, actionCustomFieldValueTextArea)"></app-variables>
                              }

                              @if (getCustomField(action.customField)?.type === 'rich-text') {
                                <div class="action-button-rich-text-input me-2">
                                  <input #actionRichTextValuePopover="ngbPopover"
                                         type="text"
                                         [(ngModel)]="action.value"
                                         [disabled]="!campaignMeta['action_buttons_active']"
                                         placeholder="Value"
                                         class="form-control"
                                         readonly
                                         [autoClose]="'outside'"
                                         [ngbPopover]="actionCustomFieldRichTextEditorPopup"
                                         popoverClass="custom-field-default-value-editor-popover"
                                         placement="auto"
                                         container="body" />
                                  <ng-template #actionCustomFieldRichTextEditorPopup>
                                    <app-sb-rich-text
                                      #actionCustomFieldEditor
                                      class="custom-field-default-value-popup-editor"
                                      [tools]="getActionCustomFieldEditorConfig(action.customField, action).tools"
                                      [height]="getActionCustomFieldEditorConfig(action.customField, action).height"
                                      [multiline]="getActionCustomFieldEditorConfig(action.customField, action).multiline"
                                      [html]="getActionCustomFieldEditorData(action.customField, action.value, action)"
                                      (ready)="registerActionRichTextEditor(action, actionCustomFieldEditor)"
                                      (htmlChange)="onActionRichTextEditorChange(action, $event, actionCustomFieldEditor)"
                                      shape="inline"
                                      [inlineStyles]="true"
                                      [linkUnderlineToggle]="true"
                                      [autoGrow]="true"
                                      [resizable]="true">
                                    </app-sb-rich-text>
                                  </ng-template>
                                </div>
                                <app-variables [variableClickFor]="'action_rich_text_' + i + '_' + j"
                                              (onVariableClick)="onActionRichTextVariableClick($event, action)"
                                              class="me-2"></app-variables>
                              }

                              @if (getCustomField(action.customField)?.type === 'color') {
                                @if (!containsHashPattern(action.value)) {
                                <input class="form-control me-2 action-button-color-input" type='text' [value]="action.value"
                                    [(ngModel)]="action.value" (ngModelChange)="onSettingsChange($event)" (change)="action.value = $event.target.value" [disabled]="!campaignMeta['action_buttons_active']" placeholder="rgba(225, 226, 231, 1)" appColorPicker [appColorPickerAlpha]="true"/>
                                }

                                @if (containsHashPattern(action.value)) {
                                <input #customFieldInput type="text" [(ngModel)]="action.value" (ngModelChange)="onSettingsChange($event)" [disabled]="!campaignMeta['action_buttons_active']" placeholder="Value" class="form-control me-2" [attr.title]="action.value || null" />
                                }
                                <app-variables [variableClickFor]="'action_color_' + i + '_' + j" [fieldType]="'color'"
                                              (onVariableClick)="onVariableClickForActionTriggerCustomFields($event, button, action, customFieldInput)"></app-variables>
                              }

                              @if (getCustomField(action.customField)?.type === 'image') {
                                @if (!containsHashPattern(action.value)) {
                                <app-file-browser [clientId]="$safeNavigationMigration(campaign?.client_id)" [projectId]="$safeNavigationMigration(campaign?.project_id)" [selectedImage]="action.value" [enableChoose]="true" defaultIcon="fa fa-image" imageWidth="64px" imageHeight="64px" (fileSelected)="onCustomFieldActionValueSelected($event, action)" [disabled]="!campaignMeta['action_buttons_active']" class="me-2"></app-file-browser>
                                }

                                @if (containsHashPattern(action.value)) {
                                <input #customFieldInput type="text" [(ngModel)]="action.value" (ngModelChange)="onSettingsChange($event)" [disabled]="!campaignMeta['action_buttons_active']" placeholder="Value" class="form-control me-2" [attr.title]="action.value || null" />
                                }
                                <app-variables [variableClickFor]="'action_image_' + i + '_' + j" [fieldType]="'image'"
                                              (onVariableClick)="onVariableClickForActionTriggerCustomFields($event, button, action, customFieldInput)"></app-variables>
                              }
                            </div>
                          }

                          <!-- set_widget_settings -->
                          @if (getActionEditorType(action) === 'set_widget_settings') {
                            <div class='flex-fill input-group-sm variable-input action-button-input'>
                              <select [(ngModel)]="action.settingKey" (ngModelChange)="onWidgetSettingKeyChange(action)" class="form-control me-2" [disabled]="!campaignMeta['action_buttons_active']">
                                <option value="" disabled></option>
                                @for (s of widgetSettingKeys; track s) {
                                <option [value]="s.key"
                                        [disabled]="getUsedWidgetSettingKeys(button).includes(s.key) && action.settingKey !== s.key">
                                  {{ s.label }}
                                </option>
                                }
                              </select>
                            </div>
                            <div class='flex-fill input-group-sm variable-input action-button-input'>
                              @if (action.settingKey === 'language') {
                                <app-sb-input-language
                                  [(ngModel)]="action.value"
                                  (selectionChange)="onSettingsChange($event)"
                                  [id]="'action_widget_language_' + i + '_' + j"
                                  placeholder="No language change"
                                  label=""
                                  [disabled]="!campaignMeta['action_buttons_active']">
                                </app-sb-input-language>
                              }
                              @if (isRichTextWidgetSettingKey(action.settingKey)) {
                              <div class="action-button-rich-text-input me-2">
                                <input #actionRichTextValuePopover="ngbPopover"
                                  type="text"
                                  class="form-control"
                                  [(ngModel)]="action.value"
                                  placeholder="Value"
                                  readonly
                                  [autoClose]="'outside'"
                                  [ngbPopover]="actionWidgetSettingRichTextEditorPopup"
                                  popoverClass="custom-field-default-value-editor-popover"
                                  placement="auto"
                                  container="body"
                                  [disabled]="!campaignMeta['action_buttons_active']" />
                                <ng-template #actionWidgetSettingRichTextEditorPopup>
                                  <app-sb-rich-text
                                    #actionWidgetSettingEditor
                                    class="custom-field-default-value-popup-editor"
                                    [tools]="getActionWidgetSettingEditorConfig(action.settingKey, action).tools"
                                    [height]="getActionWidgetSettingEditorConfig(action.settingKey, action).height"
                                    [multiline]="getActionWidgetSettingEditorConfig(action.settingKey, action).multiline"
                                    [html]="getActionWidgetSettingEditorData(action.settingKey, action.value, action)"
                                    (htmlChange)="onActionRichTextEditorChange(action, $event, actionWidgetSettingEditor)"
                                    shape="inline"
                                    [inlineStyles]="true"
                                    [linkUnderlineToggle]="true"
                                    [autoGrow]="true"
                                    [resizable]="true">
                                  </app-sb-rich-text>
                                </ng-template>
                              </div>
                              }
                              @if (action.settingKey && action.settingKey !== 'language' && !isRichTextWidgetSettingKey(action.settingKey)) {
                              <input type="text" class="form-control me-2"
                                [(ngModel)]="action.value"
                                (ngModelChange)="action.value = $event || null; onSettingsChange($event)"
                                placeholder="Value"
                                [attr.title]="action.value || null"
                                [disabled]="!campaignMeta['action_buttons_active']" />
                              }
                            </div>
                          }

                          @if (getActionEditorType(action) === 'set_meta_media') {
                            <div class='flex-fill input-group-sm variable-input action-button-input'>
                              <select [(ngModel)]="action.settingKey" (ngModelChange)="onMetaMediaSettingKeyChange(action)" class="form-control me-2" [disabled]="!campaignMeta['action_buttons_active']">
                                <option value="" disabled></option>
                                @for (setting of metaMediaSettingKeys; track setting) {
                                <option [value]="setting.key"
                                        [disabled]="getUsedMetaMediaSettingKeys(button).includes(setting.key) && action.settingKey !== setting.key">
                                  {{ setting.label }}
                                </option>
                                }
                              </select>
                            </div>
                            <div class='flex-fill input-group-sm variable-input action-button-input'>
                              @if (action.settingKey) {
                              <app-file-browser
                                [clientId]="$safeNavigationMigration(campaign?.client_id)"
                                [projectId]="$safeNavigationMigration(campaign?.project_id)"
                                [selectedImage]="action.value"
                                [enableChoose]="true"
                                [type]="action.settingKey === 'meta_video' ? 'video' : 'image'"
                                [defaultIcon]="action.settingKey === 'meta_video' ? 'fa fa-video-camera' : 'fa fa-image'"
                                imageWidth="96px"
                                imageHeight="64px"
                                (fileSelected)="onMetaMediaActionValueSelected($event, action)"
                                [disabled]="!campaignMeta['action_buttons_active']"
                                class="me-2">
                              </app-file-browser>
                              }
                            </div>
                          }
                          </div>

                          <div>
                            <button
                              class="btn btn-sm rounded-circle me-2 text-white my-0 ms-0 p-0 d-flex align-items-center justify-content-center add-button"
                              type="button"
                              (click)="addAction(button, j)"
                              [disabled]="!campaignMeta['action_buttons_active']"
                            >
                              <span class="btn-wrapper--icon"><i class="fa fa-plus"></i></span>
                            </button>
                          </div>
                        </div>
                      </div>
                      }
                    </div>
                    }

              </div>
</ng-template>

<ng-template #influencerFieldsSectionBody>
              <div class="settings-group">
                <div class="row">
                  <div class="col-12">
                    <div class="influencer-fields-scroll-wrapper">
                      <table class="influencer-fields-table">
                        <thead>
                          <tr>
                            <th class="influencer-fields-handle-cell"></th>
                            <th class="influencer-fields-toggle-cell"></th>
                            <th>Tab</th>
                            <th>Group</th>
                            <th>Name</th>
                            <th class="influencer-fields-boolean-cell">Read Only</th>
                            <th class="influencer-fields-boolean-cell">Required</th>
                            <th>Label</th>
                            <th class="influencer-fields-type-cell">Type</th>
                            <th>Default Value</th>
                            <th class="influencer-fields-boolean-cell">Default Fallback</th>
                          </tr>
                        </thead>
                        <tbody class="influencer-fields-table-body"
                               cdkDropList
                               [cdkDropListDisabled]="!campaignMeta['influencer_fields_active']"
                               (cdkDropListDropped)="dropCustomField($event)">
                          @for (field of campaignMeta.influencer_fields; track field; let i = $index) {
                          <tr
                              class="influencer-fields-row"
                              cdkDrag
                              cdkDragLockAxis="y"
                              (cdkDragEnded)="clearInfluencerFieldDragTransforms()"
                              [cdkDragDisabled]="isInfluencerFieldConfigDisabled(field)">
                            <td class="influencer-fields-handle-cell" cdkDragHandle>
                              <span class="material-icons text-muted influencer-fields-drag-icon">
                                drag_indicator
                              </span>
                            </td>
                            <td class="influencer-fields-toggle-cell">
                              @if (!isInfluencerPictureField(field)) {
                                <input type="checkbox"
                                       [ngModel]="getInfluencerFieldEnabled(field)"
                                       (ngModelChange)="onInfluencerFieldEnabledChange(field, $event)"
                                       [id]="'customFieldEnabled' + i"
                                       [disabled]="isInfluencerFieldEnabledToggleDisabled(field)">
                              } @else {
                                <span class="influencer-fields-empty-cell"></span>
                              }
                            </td>
                            <td class="influencer-fields-text-cell">
                              <input type="text"
                                     [(ngModel)]="field.tab"
                                     (ngModelChange)="onSettingsChange($event)"
                                     class="form-control form-control-sm"
                                     placeholder="Tab"
                                     [disabled]="isInfluencerFieldConfigDisabled(field)">
                            </td>
                            <td class="influencer-fields-text-cell">
                              <input type="text"
                                     [(ngModel)]="field.group"
                                     (ngModelChange)="onSettingsChange($event)"
                                     class="form-control form-control-sm"
                                     placeholder="Group"
                                     [disabled]="isInfluencerFieldConfigDisabled(field)">
                            </td>
                            <td class="influencer-fields-name-cell">
                              {{ field.label }}
                            </td>
                            <td class="influencer-fields-check-cell influencer-fields-boolean-cell">
                              @if (!isInfluencerPictureField(field) && (field.key !== 'email' || isPrimaryInfoFieldDisplayLocked(field))) {
                              <input
                                     type="checkbox"
                                     [(ngModel)]="field.read_only"
                                     (ngModelChange)="onSettingsChange($event)"
                                     [id]="'customFieldReadOnly' + i"
                                     [disabled]="isInfluencerFieldValueConfigDisabled(field)">
                              } @else {
                                <span class="influencer-fields-empty-cell"></span>
                              }
                            </td>
                            <td class="influencer-fields-check-cell influencer-fields-boolean-cell">
                              @if (field.field_type === 'custom' || isInfluencerPictureField(field)) {
                              <input
                                     type="checkbox"
                                     [(ngModel)]="field.required"
                                     (ngModelChange)="onSettingsChange($event)"
                                     [id]="'customFieldRequired' + i"
                                     [disabled]="isInfluencerFieldValueConfigDisabled(field)">
                              } @else {
                                <span class="influencer-fields-empty-cell"></span>
                              }
                            </td>
                            <td class="influencer-fields-text-cell">
                              @if (field.field_type === 'custom' || field.field_type === 'primary' || isInfluencerPictureField(field)) {
                              <input
                                     type="text"
                                     [(ngModel)]="field.title"
                                     (ngModelChange)="onSettingsChange($event)"
                                     class="form-control form-control-sm"
                                     placeholder="Label"
                                     [attr.maxlength]="getInfluencerFieldLabelMaxLength(field)"
                                     [disabled]="isInfluencerFieldValueConfigDisabled(field)">
                              } @else {
                                <span class="influencer-fields-empty-cell"></span>
                              }
                            </td>
                            <td class="influencer-fields-type-cell">
                              <div class="influencer-fields-type-control">
                                @if (field.field_type === 'custom') {
                                <select
                                        class="form-control form-control-sm"
                                        [(ngModel)]="field.type"
                                        (ngModelChange)="onInfluencerFieldTypeChange(field, $event)"
                                        [disabled]="isInfluencerFieldValueConfigDisabled(field)">
                                  <option value="text">Text</option>
                                  <option value="email">Email</option>
                                  <option value="text-multi-line">Text (Multi-line)</option>
                                  <option value="rich-text">Rich Text</option>
                                  <option value="color">Color</option>
                                  <option value="image">Image</option>
                                  <option value="video-recorder">Video Recorder (Premium)</option>
                                </select>
                                } @else {
                                  <span class="influencer-fields-empty-cell influencer-fields-type-placeholder"></span>
                                }
                                @if (hasInfluencerFieldSettingsButton(field)) {
                                <button
                                        type="button"
                                        class="influencer-field-settings-button"
                                        [class.active]="hasInfluencerFieldEditableSettings(field)"
                                        [class.inherited]="!canEditInfluencerFieldSettings(field)"
                                        [class.config-disabled]="isInfluencerFieldConfigDisabled(field)"
                                        (click)="onInfluencerFieldSettingsClick(field, influencerFieldVideoSettingsModal, influencerFieldImageSettingsModal, influencerFieldInheritedSettingsModal)"
                                        title="Field settings">
                                  <i class="fa fa-cog" aria-hidden="true"></i>
                                </button>
                                } @else {
                                  <span class="influencer-fields-empty-cell influencer-fields-settings-placeholder"></span>
                                }
                              </div>
                            </td>
                            <td class="influencer-fields-default-cell">
                              @if (field.field_type === 'custom') {
                                @if (field.type === 'text' || field.type === 'email') {
                                <input type="text"
                                       [(ngModel)]="field.defaultValue"
                                       (ngModelChange)="onSettingsChange($event)"
                                       class="form-control form-control-sm"
                                       placeholder="Default Value"
                                       [attr.title]="field.defaultValue || null"
                                       [disabled]="isInfluencerFieldValueConfigDisabled(field)">
                                }

                                @if (field.type === 'text-multi-line') {
                                <textarea
                                          [(ngModel)]="field.defaultValue"
                                          (ngModelChange)="onSettingsChange($event)"
                                          class="form-control form-control-sm"
                                          placeholder="Default Value"
                                          rows="1"
                                          style="overflow:hidden; resize:none"
                                          [appAutoGrow]="field.defaultValue"
                                          [disabled]="isInfluencerFieldValueConfigDisabled(field)"
                                          #customFieldValueTextArea></textarea>
                                }

                                @if (field.type === 'rich-text') {
                                <div class="influencer-fields-rich-default-input">
                                  <input type="text"
                                         #customFieldDefaultValuePopover="ngbPopover"
                                         [(ngModel)]="field.defaultValue"
                                         class="form-control form-control-sm"
                                         placeholder="Default Value"
                                         readonly
                                         [autoClose]="'outside'"
                                         [ngbPopover]="customFieldDefaultValueEditorPopup"
                                         popoverClass="custom-field-default-value-editor-popover"
                                         placement="auto"
                                         container="body"
                                         [disabled]="isInfluencerFieldValueConfigDisabled(field)">
                                </div>
                                }

                                <ng-template #customFieldDefaultValueEditorPopup>
                                  <app-sb-rich-text
                                    #customFieldDefaultValueEditor
                                    class="custom-field-default-value-popup-editor"
                                    [tools]="getCustomFieldEditorConfig(field).tools"
                                    [height]="getCustomFieldEditorConfig(field).height"
                                    [multiline]="getCustomFieldEditorConfig(field).multiline"
                                    [html]="getCustomFieldEditorData(field.defaultValue, field)"
                                    (htmlChange)="onCustomFieldDefaultValueEditorChange(field, $event, customFieldDefaultValueEditor)"
                                    shape="inline"
                                    [inlineStyles]="true"
                                    [linkUnderlineToggle]="true"
                                    [autoGrow]="true"
                                    [resizable]="true">
                                  </app-sb-rich-text>
                                </ng-template>

                                @if (field.type === 'color') {
                                <input
                                       class="form-control form-control-sm influencer-fields-color-default-picker"
                                       type="text"
                                       [value]="field.defaultValue || ''"
                                       [ngModel]="field.defaultValue || ''"
                                       (ngModelChange)="onCustomFieldColorDefaultValueChange(field, $event)"
                                       placeholder="rgba(225, 226, 231, 1)"
                                       [disabled]="isInfluencerFieldValueConfigDisabled(field)"
                                       appColorPicker
                                       [appColorPickerAlpha]="true"
                                       [appColorPickerSwatchOnly]="true"
                                       [appColorPickerEmptyIndicator]="true"/>
                                }

                                @if (field.type === 'image') {
                                <app-file-browser [clientId]="$safeNavigationMigration(campaign?.client_id)" [projectId]="$safeNavigationMigration(campaign?.project_id)" [selectedImage]="field.defaultValue" [enableChoose]="true" defaultIcon="fa fa-image" imageWidth="64px" imageHeight="64px" (fileSelected)="onCustomFieldDefaultValueSelected($event, field)" [disabled]="isInfluencerFieldValueConfigDisabled(field)" class="influencer-fields-file-browser"></app-file-browser>
                                }

                                @if (field.type === 'video-recorder') {
                                <app-file-browser [clientId]="$safeNavigationMigration(campaign?.client_id)" [projectId]="$safeNavigationMigration(campaign?.project_id)" [selectedImage]="field.defaultValue" [enableChoose]="true" type="video" defaultIcon="fa fa-video-camera" imageWidth="96px" imageHeight="64px" (fileSelected)="onCustomFieldDefaultValueSelected($event, field)" [disabled]="isInfluencerFieldValueConfigDisabled(field)" class="influencer-fields-file-browser"></app-file-browser>
                                }
                              } @else {
                                <span class="influencer-fields-empty-cell"></span>
                              }
                            </td>
                            <td class="influencer-fields-check-cell influencer-fields-boolean-cell">
                              @if (field.field_type === 'custom') {
                              <input
                                     type="checkbox"
                                     [(ngModel)]="field.default_fallback"
                                     (ngModelChange)="onSettingsChange($event)"
                                     [id]="'customFieldDefaultFallback' + i"
                                     [disabled]="isInfluencerFieldValueConfigDisabled(field)">
                              } @else {
                                <span class="influencer-fields-empty-cell"></span>
                              }
                            </td>
                          </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
</ng-template>

<ng-template #snoflexSectionModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Snoflex - Advanced Widget</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('cancel')"></button>
  </div>
  <div class="modal-body modern-settings-section">
    @if (expandedSectionKey === 'action_buttons') {
    <ng-container [ngTemplateOutlet]="snoflexSectionBody"></ng-container>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="modal.dismiss('cancel')">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="saveExpandedSection(modal)">Save</button>
  </div>
</ng-template>

<ng-template #influencerFieldsSectionModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Customize Influencer Fields</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('cancel')"></button>
  </div>
  <div class="modal-body modern-settings-section influencer-fields-tab-content">
    @if (expandedSectionKey === 'custom_fields') {
    <ng-container [ngTemplateOutlet]="influencerFieldsSectionBody"></ng-container>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="modal.dismiss('cancel')">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="saveExpandedSection(modal)">Save</button>
  </div>
</ng-template>

<ng-template #advancedImageSettingsModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Advanced Image Settings</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('cancel')"></button>
  </div>
  <div class="modal-body">
    <h6 class="text-uppercase text-muted fw-bold mb-3">Size</h6>
    <div class="row">
      <div class="col-md-6">
        <div class="mb-3">
          <label>Min Width</label>
          <div class="input-group">
          <input type="number"
                 min="0"
                 class="form-control"
                 [(ngModel)]="campaignMeta['widget_profile_picture_min_width']"
                 placeholder="0">
            <span class="input-group-text">px</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label>Min Height</label>
          <div class="input-group">
          <input type="number"
                 min="0"
                 class="form-control"
                 [(ngModel)]="campaignMeta['widget_profile_picture_min_height']"
                 placeholder="10">
            <span class="input-group-text">px</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="modal.dismiss('cancel')">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="saveWidgetAdvancedSettings(modal)">Save Settings</button>
  </div>
</ng-template>

<ng-template #advancedVideoSettingsModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Advanced Video Settings</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('cancel')"></button>
  </div>
  <div class="modal-body">
    <h6 class="text-uppercase text-muted fw-bold mb-3">Recording</h6>
    <div class="mb-3">
      <input id="campaign_widget_profile_video_enable_recorder"
             type="checkbox"
             class="styled-checkbox"
             [(ngModel)]="campaignMeta['widget_profile_video_enable_recorder']">
      <label for="campaign_widget_profile_video_enable_recorder" class="ms-1">Enable Recorder</label>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="mb-3">
          <label>Min Duration</label>
          <div class="input-group">
            <input type="number" min="0" class="form-control" [(ngModel)]="campaignMeta['widget_profile_video_min_duration']" placeholder="0">
            <span class="input-group-text">sec</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label>Max Duration</label>
          <div class="input-group">
            <input type="number" min="0" class="form-control" [(ngModel)]="campaignMeta['widget_profile_video_max_duration']" placeholder="10">
            <span class="input-group-text">sec</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label>Min Width</label>
          <div class="input-group">
            <input type="number" min="0" class="form-control" [(ngModel)]="campaignMeta['widget_profile_video_min_width']" placeholder="0">
            <span class="input-group-text">px</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label>Min Height</label>
          <div class="input-group">
            <input type="number" min="0" class="form-control" [(ngModel)]="campaignMeta['widget_profile_video_min_height']" placeholder="0">
            <span class="input-group-text">px</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label>Target Aspect Width</label>
          <div class="input-group">
            <input type="number" min="0" class="form-control" [(ngModel)]="campaignMeta['widget_profile_video_target_aspect_width']" placeholder="0">
            <span class="input-group-text">ratio</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label>Target Aspect Height</label>
          <div class="input-group">
            <input type="number" min="0" class="form-control" [(ngModel)]="campaignMeta['widget_profile_video_target_aspect_height']" placeholder="0">
            <span class="input-group-text">ratio</span>
          </div>
        </div>
      </div>
    </div>

    @if (campaignMeta['widget_profile_video_enable_recorder']) {
    <h6 class="text-uppercase text-muted fw-bold mb-3 mt-3">Captions</h6>
    <div class="mb-3">
      <label class="d-block">Caption Mode</label>
      <div class="form-check form-check-inline form-check-native">
        <input id="campaign_caption_mode_auto"
               class="form-check-input"
               type="radio"
               name="campaign_caption_mode"
               value="auto"
               [(ngModel)]="campaignMeta['widget_profile_video_caption_mode']">
        <label class="form-check-label" for="campaign_caption_mode_auto">Auto</label>
      </div>
      <div class="form-check form-check-inline form-check-native">
        <input id="campaign_caption_mode_let_user_decide"
               class="form-check-input"
               type="radio"
               name="campaign_caption_mode"
               value="let_user_decide"
               [(ngModel)]="campaignMeta['widget_profile_video_caption_mode']">
        <label class="form-check-label" for="campaign_caption_mode_let_user_decide">Let user decide</label>
      </div>
      <div class="form-check form-check-inline form-check-native">
        <input id="campaign_caption_mode_disabled"
               class="form-check-input"
               type="radio"
               name="campaign_caption_mode"
               value="disabled"
               [(ngModel)]="campaignMeta['widget_profile_video_caption_mode']">
        <label class="form-check-label" for="campaign_caption_mode_disabled">Disabled</label>
      </div>
    </div>
    @if (campaignMeta['widget_profile_video_caption_mode'] !== 'disabled') {
    <div class="row">
      <div class="col-md-12">
        <div class="mb-3">
          <label>Caption Font</label>
          <div class="input-group">
            <input type="text"
                   class="form-control"
                   [value]="getVideoCaptionFontLabel(campaignMeta)"
                   readonly>
            <button type="button"
                    class="btn btn-default"
                    (click)="openVideoCaptionFontBrowser(campaignMeta, widgetVideoCaptionFontBrowserModal)">
              Browse
            </button>
            <button type="button"
                    class="btn btn-default"
                    (click)="clearVideoCaptionFont(campaignMeta)">
              Clear
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="mb-3">
          <label class="d-block">Caption Position</label>
          <div class="form-check form-check-inline form-check-native">
            <input id="campaign_caption_position_top"
                   class="form-check-input"
                   type="radio"
                   name="campaign_caption_position"
                   value="top"
                   [(ngModel)]="campaignMeta['widget_profile_video_caption_position']">
            <label class="form-check-label" for="campaign_caption_position_top">Top</label>
          </div>
          <div class="form-check form-check-inline form-check-native">
            <input id="campaign_caption_position_center"
                   class="form-check-input"
                   type="radio"
                   name="campaign_caption_position"
                   value="center"
                   [(ngModel)]="campaignMeta['widget_profile_video_caption_position']">
            <label class="form-check-label" for="campaign_caption_position_center">Middle</label>
          </div>
          <div class="form-check form-check-inline form-check-native">
            <input id="campaign_caption_position_bottom"
                   class="form-check-input"
                   type="radio"
                   name="campaign_caption_position"
                   value="bottom"
                   [(ngModel)]="campaignMeta['widget_profile_video_caption_position']">
            <label class="form-check-label" for="campaign_caption_position_bottom">Bottom</label>
          </div>
        </div>
        <div class="mb-3">
          <input id="campaign_widget_profile_video_caption_background_enabled"
                 type="checkbox"
                 class="styled-checkbox"
                 [(ngModel)]="campaignMeta['widget_profile_video_caption_background_enabled']">
          <label for="campaign_widget_profile_video_caption_background_enabled" class="ms-1">Enable Caption Background</label>
        </div>
      </div>
      @if (campaignMeta['widget_profile_video_caption_background_enabled']) {
      <div class="col-md-6">
        <div class="mb-3">
          <label>Caption Background Color</label>
          <div class="row">
            <div class="col-3 pe-1">
              <input type="color" class="form-control p-1" [(ngModel)]="campaignMeta['widget_profile_video_caption_background_color']">
            </div>
            <div class="col-9 ps-1">
              <input type="text" class="form-control" [(ngModel)]="campaignMeta['widget_profile_video_caption_background_color']">
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label>Opacity: {{campaignMeta['widget_profile_video_caption_background_opacity']}}%</label>
          <input type="range"
                 class="form-range"
                 min="0"
                 max="100"
                 [(ngModel)]="campaignMeta['widget_profile_video_caption_background_opacity']">
        </div>
      </div>
      }
      <div class="col-md-6">
        <div class="mb-3">
          <label>Font Color</label>
          <div class="row">
            <div class="col-3 pe-1">
              <input type="color" class="form-control p-1" [(ngModel)]="campaignMeta['widget_profile_video_caption_font_color']">
            </div>
            <div class="col-9 ps-1">
              <input type="text" class="form-control" [(ngModel)]="campaignMeta['widget_profile_video_caption_font_color']">
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label>Opacity: {{campaignMeta['widget_profile_video_caption_font_opacity']}}%</label>
          <input type="range"
                 class="form-range"
                 min="0"
                 max="100"
                 [(ngModel)]="campaignMeta['widget_profile_video_caption_font_opacity']">
        </div>
      </div>
    </div>
    }

    <h6 class="text-uppercase text-muted fw-bold mb-3 mt-3">Background</h6>
    <div class="mb-3">
      <label class="d-block">Background Mode</label>
      <div class="form-check form-check-inline form-check-native">
        <input id="campaign_background_mode_auto"
               class="form-check-input"
               type="radio"
               name="campaign_background_mode"
               value="auto"
               [(ngModel)]="campaignMeta['widget_profile_video_background_mode']">
        <label class="form-check-label" for="campaign_background_mode_auto">Auto</label>
      </div>
      <div class="form-check form-check-inline form-check-native">
        <input id="campaign_background_mode_let_user_decide"
               class="form-check-input"
               type="radio"
               name="campaign_background_mode"
               value="let_user_decide"
               [(ngModel)]="campaignMeta['widget_profile_video_background_mode']">
        <label class="form-check-label" for="campaign_background_mode_let_user_decide">Let user decide</label>
      </div>
      <div class="form-check form-check-inline form-check-native">
        <input id="campaign_background_mode_disabled"
               class="form-check-input"
               type="radio"
               name="campaign_background_mode"
               value="disabled"
               [(ngModel)]="campaignMeta['widget_profile_video_background_mode']">
        <label class="form-check-label" for="campaign_background_mode_disabled">Disabled</label>
      </div>
    </div>
    @if (campaignMeta['widget_profile_video_background_mode'] !== 'disabled') {
    <div class="mb-3">
      <label>Background Color</label>
      <div class="row">
        <div class="col-2 pe-1">
          <input type="color" class="form-control p-1" [(ngModel)]="campaignMeta['widget_profile_video_background_color']">
        </div>
        <div class="col-10 ps-1">
          <input type="text" class="form-control" [(ngModel)]="campaignMeta['widget_profile_video_background_color']">
        </div>
      </div>
    </div>
    }

    <h6 class="text-uppercase text-muted fw-bold mb-3 mt-3">Teleprompter</h6>
    <div class="mb-3">
      <input id="campaign_widget_profile_video_enable_teleprompter"
             type="checkbox"
             class="styled-checkbox"
             [(ngModel)]="campaignMeta['widget_profile_video_enable_teleprompter']">
      <label for="campaign_widget_profile_video_enable_teleprompter" class="ms-1">Enable Teleprompter</label>
    </div>
    @if (campaignMeta['widget_profile_video_enable_teleprompter']) {
    <div class="mb-3">
      <label>Speed: {{campaignMeta['widget_profile_video_teleprompter_speed']}}ms</label>
      <div class="d-flex align-items-center">
        <span class="me-2">100ms</span>
        <input type="range"
               class="form-range"
               min="100"
               max="500"
               step="10"
               [(ngModel)]="campaignMeta['widget_profile_video_teleprompter_speed']">
        <span class="ms-2">500ms</span>
      </div>
    </div>
    }
    @if (campaignMeta['widget_profile_video_enable_teleprompter']) {
    <div class="mb-0">
      <label>Question</label>
      <textarea class="form-control"
                rows="4"
                [(ngModel)]="campaignMeta['widget_profile_video_teleprompter_question']"
                placeholder="Write your questions here..."></textarea>
      <small class="form-text text-muted">Can only be used when teleprompter is enabled</small>
    </div>
    }
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="modal.dismiss('cancel')">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="saveWidgetAdvancedSettings(modal)">Save Settings</button>
  </div>
</ng-template>

<ng-template #influencerFieldInheritedSettingsModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Inherited Settings</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('cancel')"></button>
  </div>
  <div class="modal-body">
    <p class="influencer-field-inherited-settings-message">
      {{ influencerFieldInheritedSettingsMessage }}
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modal.close()">OK</button>
  </div>
</ng-template>

<ng-template #influencerFieldImageSettingsModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Advanced Image Settings</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('cancel')"></button>
  </div>
  @if (selectedInfluencerFieldImageSettings) {
  <div class="modal-body">
    <h6 class="text-uppercase text-muted fw-bold mb-3">Size</h6>
    <div class="row">
      <div class="col-md-6">
        <div class="mb-3">
          <label>Min Width</label>
          <div class="input-group">
            <input type="number"
                   min="0"
                   class="form-control"
                   [(ngModel)]="selectedInfluencerFieldImageSettings['widget_profile_picture_min_width']"
                   placeholder="0">
            <span class="input-group-text">px</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label>Min Height</label>
          <div class="input-group">
            <input type="number"
                   min="0"
                   class="form-control"
                   [(ngModel)]="selectedInfluencerFieldImageSettings['widget_profile_picture_min_height']"
                   placeholder="10">
            <span class="input-group-text">px</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="modal.dismiss('cancel')">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="saveInfluencerFieldImageSettings(modal)">Save Settings</button>
  </div>
</ng-template>

<ng-template #influencerFieldVideoSettingsModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Advanced Video Settings</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('cancel')"></button>
  </div>
  @if (selectedInfluencerFieldVideoSettings) {
  <div class="modal-body">
    <h6 class="text-uppercase text-muted fw-bold mb-3">Recording</h6>
    <div class="mb-3">
      <input id="field_widget_profile_video_enable_recorder"
             type="checkbox"
             class="styled-checkbox"
             [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_enable_recorder']">
      <label for="field_widget_profile_video_enable_recorder" class="ms-1">Enable Recorder</label>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="mb-3">
          <label>Min Duration</label>
          <div class="input-group">
            <input type="number" min="0" class="form-control" [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_min_duration']" placeholder="0">
            <span class="input-group-text">sec</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label>Max Duration</label>
          <div class="input-group">
            <input type="number" min="0" class="form-control" [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_max_duration']" placeholder="10">
            <span class="input-group-text">sec</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label>Min Width</label>
          <div class="input-group">
            <input type="number" min="0" class="form-control" [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_min_width']" placeholder="0">
            <span class="input-group-text">px</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label>Min Height</label>
          <div class="input-group">
            <input type="number" min="0" class="form-control" [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_min_height']" placeholder="0">
            <span class="input-group-text">px</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label>Target Aspect Width</label>
          <div class="input-group">
            <input type="number" min="0" class="form-control" [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_target_aspect_width']" placeholder="0">
            <span class="input-group-text">ratio</span>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label>Target Aspect Height</label>
          <div class="input-group">
            <input type="number" min="0" class="form-control" [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_target_aspect_height']" placeholder="0">
            <span class="input-group-text">ratio</span>
          </div>
        </div>
      </div>
    </div>

    @if (selectedInfluencerFieldVideoSettings['widget_profile_video_enable_recorder']) {
    <h6 class="text-uppercase text-muted fw-bold mb-3 mt-3">Captions</h6>
    <div class="mb-3">
      <label class="d-block">Caption Mode</label>
      <div class="form-check form-check-inline form-check-native">
        <input id="field_caption_mode_auto"
               class="form-check-input"
               type="radio"
               name="field_caption_mode"
               value="auto"
               [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_caption_mode']">
        <label class="form-check-label" for="field_caption_mode_auto">Auto</label>
      </div>
      <div class="form-check form-check-inline form-check-native">
        <input id="field_caption_mode_let_user_decide"
               class="form-check-input"
               type="radio"
               name="field_caption_mode"
               value="let_user_decide"
               [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_caption_mode']">
        <label class="form-check-label" for="field_caption_mode_let_user_decide">Let user decide</label>
      </div>
      <div class="form-check form-check-inline form-check-native">
        <input id="field_caption_mode_disabled"
               class="form-check-input"
               type="radio"
               name="field_caption_mode"
               value="disabled"
               [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_caption_mode']">
        <label class="form-check-label" for="field_caption_mode_disabled">Disabled</label>
      </div>
    </div>
    @if (selectedInfluencerFieldVideoSettings['widget_profile_video_caption_mode'] !== 'disabled') {
    <div class="row">
      <div class="col-md-12">
        <div class="mb-3">
          <label>Caption Font</label>
          <div class="input-group">
            <input type="text"
                   class="form-control"
                   [value]="getVideoCaptionFontLabel(selectedInfluencerFieldVideoSettings)"
                   readonly>
            <button type="button"
                    class="btn btn-default"
                    (click)="openVideoCaptionFontBrowser(selectedInfluencerFieldVideoSettings, widgetVideoCaptionFontBrowserModal)">
              Browse
            </button>
            <button type="button"
                    class="btn btn-default"
                    (click)="clearVideoCaptionFont(selectedInfluencerFieldVideoSettings)">
              Clear
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="mb-3">
          <label class="d-block">Caption Position</label>
          <div class="form-check form-check-inline form-check-native">
            <input id="field_caption_position_top"
                   class="form-check-input"
                   type="radio"
                   name="field_caption_position"
                   value="top"
                   [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_caption_position']">
            <label class="form-check-label" for="field_caption_position_top">Top</label>
          </div>
          <div class="form-check form-check-inline form-check-native">
            <input id="field_caption_position_center"
                   class="form-check-input"
                   type="radio"
                   name="field_caption_position"
                   value="center"
                   [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_caption_position']">
            <label class="form-check-label" for="field_caption_position_center">Middle</label>
          </div>
          <div class="form-check form-check-inline form-check-native">
            <input id="field_caption_position_bottom"
                   class="form-check-input"
                   type="radio"
                   name="field_caption_position"
                   value="bottom"
                   [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_caption_position']">
            <label class="form-check-label" for="field_caption_position_bottom">Bottom</label>
          </div>
        </div>
        <div class="mb-3">
          <input id="field_widget_profile_video_caption_background_enabled"
                 type="checkbox"
                 class="styled-checkbox"
                 [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_caption_background_enabled']">
          <label for="field_widget_profile_video_caption_background_enabled" class="ms-1">Enable Caption Background</label>
        </div>
      </div>
      @if (selectedInfluencerFieldVideoSettings['widget_profile_video_caption_background_enabled']) {
      <div class="col-md-6">
        <div class="mb-3">
          <label>Caption Background Color</label>
          <div class="row">
            <div class="col-3 pe-1">
              <input type="color" class="form-control p-1" [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_caption_background_color']">
            </div>
            <div class="col-9 ps-1">
              <input type="text" class="form-control" [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_caption_background_color']">
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label>Opacity: {{selectedInfluencerFieldVideoSettings['widget_profile_video_caption_background_opacity']}}%</label>
          <input type="range"
                 class="form-range"
                 min="0"
                 max="100"
                 [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_caption_background_opacity']">
        </div>
      </div>
      }
      <div class="col-md-6">
        <div class="mb-3">
          <label>Font Color</label>
          <div class="row">
            <div class="col-3 pe-1">
              <input type="color" class="form-control p-1" [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_caption_font_color']">
            </div>
            <div class="col-9 ps-1">
              <input type="text" class="form-control" [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_caption_font_color']">
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label>Opacity: {{selectedInfluencerFieldVideoSettings['widget_profile_video_caption_font_opacity']}}%</label>
          <input type="range"
                 class="form-range"
                 min="0"
                 max="100"
                 [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_caption_font_opacity']">
        </div>
      </div>
    </div>
    }

    <h6 class="text-uppercase text-muted fw-bold mb-3 mt-3">Background</h6>
    <div class="mb-3">
      <label class="d-block">Background Mode</label>
      <div class="form-check form-check-inline form-check-native">
        <input id="field_background_mode_auto"
               class="form-check-input"
               type="radio"
               name="field_background_mode"
               value="auto"
               [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_background_mode']">
        <label class="form-check-label" for="field_background_mode_auto">Auto</label>
      </div>
      <div class="form-check form-check-inline form-check-native">
        <input id="field_background_mode_let_user_decide"
               class="form-check-input"
               type="radio"
               name="field_background_mode"
               value="let_user_decide"
               [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_background_mode']">
        <label class="form-check-label" for="field_background_mode_let_user_decide">Let user decide</label>
      </div>
      <div class="form-check form-check-inline form-check-native">
        <input id="field_background_mode_disabled"
               class="form-check-input"
               type="radio"
               name="field_background_mode"
               value="disabled"
               [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_background_mode']">
        <label class="form-check-label" for="field_background_mode_disabled">Disabled</label>
      </div>
    </div>
    @if (selectedInfluencerFieldVideoSettings['widget_profile_video_background_mode'] !== 'disabled') {
    <div class="mb-3">
      <label>Background Color</label>
      <div class="row">
        <div class="col-2 pe-1">
          <input type="color" class="form-control p-1" [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_background_color']">
        </div>
        <div class="col-10 ps-1">
          <input type="text" class="form-control" [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_background_color']">
        </div>
      </div>
    </div>
    }

    <h6 class="text-uppercase text-muted fw-bold mb-3 mt-3">Teleprompter</h6>
    <div class="mb-3">
      <input id="field_widget_profile_video_enable_teleprompter"
             type="checkbox"
             class="styled-checkbox"
             [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_enable_teleprompter']">
      <label for="field_widget_profile_video_enable_teleprompter" class="ms-1">Enable Teleprompter</label>
    </div>
    @if (selectedInfluencerFieldVideoSettings['widget_profile_video_enable_teleprompter']) {
    <div class="mb-3">
      <label>Speed: {{selectedInfluencerFieldVideoSettings['widget_profile_video_teleprompter_speed']}}ms</label>
      <div class="d-flex align-items-center">
        <span class="me-2">100ms</span>
        <input type="range"
               class="form-range"
               min="100"
               max="500"
               step="10"
               [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_teleprompter_speed']">
        <span class="ms-2">500ms</span>
      </div>
    </div>
    }
    @if (selectedInfluencerFieldVideoSettings['widget_profile_video_enable_teleprompter']) {
    <div class="mb-0">
      <label>Question</label>
      <textarea class="form-control"
                rows="4"
                [(ngModel)]="selectedInfluencerFieldVideoSettings['widget_profile_video_teleprompter_question']"
                placeholder="Write your questions here..."></textarea>
      <small class="form-text text-muted">Can only be used when teleprompter is enabled</small>
    </div>
    }
    }
  </div>
  }
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="modal.dismiss('cancel')">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="saveInfluencerFieldVideoSettings(modal)">Save Settings</button>
  </div>
</ng-template>

<ng-template #widgetVideoCaptionFontBrowserModal let-modal>
  <app-iframe-modal-shell
    #fontBrowserShell
    [src]="fontBrowserUrl"
    (close)="modal.dismiss('cancel')">
  </app-iframe-modal-shell>
  <app-file-browser
    #fontFileBrowser
    class="d-none"
    [clientId]="$safeNavigationMigration(campaign?.client_id)"
    [projectId]="$safeNavigationMigration(campaign?.project_id)"
    [type]="'font'"
    (fileSelected)="onFontBrowserFileSelected($event)">
  </app-file-browser>
</ng-template>

<ng-template #saveSharePresetModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Save campaign share preset</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('cancel')"></button>
  </div>
  <div class="modal-body share-preset-modal">
    <div class="mb-3">
      <label for="sharePresetName">Preset name</label>
      <input id="sharePresetName"
             class="form-control"
             type="text"
             [(ngModel)]="sharePresetName"
             [class.is-invalid]="sharePresetSubmitted && !sharePresetName.trim()"
             placeholder="Preset name">
      @if (sharePresetSubmitted && !sharePresetName.trim()) {
      <div class="invalid-text">Enter preset name</div>
      }
    </div>
    <div class="mb-3">
      <label for="sharePresetDescription">Description</label>
      <textarea id="sharePresetDescription"
                class="form-control"
                rows="4"
                [(ngModel)]="sharePresetDescription"
                placeholder="Preset description"></textarea>
    </div>
    <div class="share-preset-section-list">
      <label class="share-preset-check">
        <input type="checkbox" [(ngModel)]="sharePresetSections.widget_ui_customization">
        <span>Save widget UI customization</span>
      </label>
      <label class="share-preset-check">
        <input type="checkbox" [(ngModel)]="sharePresetSections.meta_texts">
        <span>Save meta texts</span>
      </label>
      <label class="share-preset-check">
        <input type="checkbox" [(ngModel)]="sharePresetSections.share_image_design">
        <span>Save share image design</span>
      </label>
      <label class="share-preset-check">
        <input type="checkbox" [(ngModel)]="sharePresetSections.custom_fields">
        <span>Save custom fields</span>
      </label>
      <label class="share-preset-check">
        <input type="checkbox" [(ngModel)]="sharePresetSections.custom_actions">
        <span>Save custom actions</span>
      </label>
    </div>
  </div>
  <div class="modal-footer justify-content-end share-preset-save-footer">
    <div class="share-preset-save-dropdown" (click)="$event.stopPropagation()">
      <button type="button"
              class="btn btn-primary dropdown-toggle share-preset-footer-btn share-preset-save-dropdown-toggle"
              (click)="toggleSharePresetSaveMenu($event)">
        <span>Save</span>
      </button>
      @if (sharePresetSaveMenuOpen) {
      <div class="share-preset-save-menu">
        @if (canCreateSharePresetScope('project')) {
        <button type="button"
                class="share-preset-save-menu-item"
                (click)="saveSharePresetAsNew(modal, 'project')">
          <span>Save as new preset</span>
        </button>
        }
        @if (canCreateSharePresetScope('client')) {
        <button type="button"
                class="share-preset-save-menu-item"
                (click)="saveSharePresetAsNew(modal, 'client')">
          <span>Save as new cross-project preset</span>
        </button>
        }
        @if (canCreateSharePresetScope('public')) {
        <button type="button"
                class="share-preset-save-menu-item"
                (click)="saveSharePresetAsNew(modal, 'public')">
          <span>Save as new public preset</span>
        </button>
        }
        @if (!canCreateSharePresetScope('project') && !canCreateSharePresetScope('client') && !canCreateSharePresetScope('public')) {
        <button type="button"
                class="share-preset-save-menu-item"
                disabled
               >
          <span>No save options available</span>
        </button>
        }
      </div>
      }
    </div>
    <button type="button" class="btn btn-default share-preset-footer-btn" (click)="modal.dismiss('cancel')">Cancel</button>
  </div>
</ng-template>

<ng-template #applySharePresetModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Apply preset</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('cancel')"></button>
  </div>
  <div class="modal-body share-preset-modal">
    <p class="mb-3 share-preset-apply-message">
      Would you like to apply the selected preset?<br>
      It may overwrite your existing customization.
    </p>
    <div class="share-preset-section-list share-preset-apply-section-list">
      <label class="share-preset-check">
        <input type="checkbox" [(ngModel)]="sharePresetApplySkips.widget_ui_customization">
        <span>Skip widget UI customization</span>
      </label>
      <label class="share-preset-check">
        <input type="checkbox" [(ngModel)]="sharePresetApplySkips.meta_texts">
        <span>Skip meta texts</span>
      </label>
      <label class="share-preset-check">
        <input type="checkbox" [(ngModel)]="sharePresetApplySkips.share_image_design">
        <span>Skip share image design</span>
      </label>
      <label class="share-preset-check">
        <input type="checkbox" [(ngModel)]="sharePresetApplySkips.custom_fields">
        <span>Skip custom fields</span>
      </label>
      <label class="share-preset-check">
        <input type="checkbox" [(ngModel)]="sharePresetApplySkips.custom_actions">
        <span>Skip custom actions</span>
      </label>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="modal.dismiss('cancel')">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="applySharePreset(modal)">Apply</button>
  </div>
</ng-template>
@if (!panelCollapsed) {
<div class="toolbar-panel-resize-handle"
     [style.left]="panelWidth + 'px'"
     (pointerdown)="startResizing($event)">
</div>
}
<button class="toolbar-panel-toggle-button"
        [style.left]="(panelCollapsed ? 0 : panelWidth) + 'px'"
        (click)="togglePanel()">
  {{ panelCollapsed ? '▶' : '◀' }}
</button>
<div  class="right-content" [style.marginLeft.px]="panelCollapsed ? 0 : panelWidth" style="transition: margin-left 0.3s;">
  <div class="container-fluid pt-3 mobile-p0 campaign-creation-steps">
    <div class='rightBody'>
      <app-status-bar [loading]="loader$ | async" [step]="step"
                      [skipLanding]="campaign?.landing_page_status === 'skipped'"
                      (SaveButtonClick)="onSaveButtonClick()">
      </app-status-bar>
      <div class="card card-box mb-8rem">
        <div class="card-header py-3">
          <div
               class="card-header--title font-size-lg d-flex align-items-baseline">
            Preview
          </div>
          <div class="card-header--actions pull-right">
          </div>
        </div>
        <div class="card-body p-0">
          @if (hasShareMedia()) {
            <!-- Influencer Navigation Bar -->
            @if (previewUrl) {
            <app-preview-influencer-nav
                                        [name]="getCurrentInfluencerName()"
                                        [index]="currentInfluencerIndex"
                                        [total]="previewInfluencers.length"
                                        [loading]="loader$ | async"
                                        [emptyLabel]="getPreviewInfluencerEmptyLabel()"
                                        (previous)="navigateToPreviousInfluencer()"
                                        (next)="navigateToNextInfluencer()">
            </app-preview-influencer-nav>
            }
            <div class="card p-3 bg-heavy-rain email-body h-100"
                 [class.preview-recorder-page]="videoRecorderPageMode"
                 style="border-radius: 0">
              @if (previewUrl) {
              <iframe #widgetPreviewIframe class="preview-iframe"
                      frameborder="0" width="100%"
                      allow="camera; microphone; display-capture; clipboard-write; fullscreen; autoplay"
                      allowfullscreen
                      (load)="onPreviewIframeLoad()"
                      [src]="previewUrl">
              </iframe>
              }
              @if (!previewUrl && previewUnavailableMessage) {
              <div class="no-image-message">
                <i class="fa fa-user-plus no-image-icon" aria-hidden="true"></i>
                <p>{{ previewUnavailableMessage }}</p>
              </div>
              }
            </div>
          } @else {
            <div class="no-image-message">
              <i class="fa fa-image no-image-icon"></i>
              <p>No template, image or video is selected yet.</p>
              <p>Please personalize or upload an image, or upload a video, to see the preview.</p>
              <button class="btn btn-primary btn-sm" (click)="scrollAndHighlightImageButtons()">
                <i class="fa fa-arrow-left me-1"></i> Select Image
              </button>
            </div>
          }
        </div>
<!--          <ng-container-->
      </div>
    </div>
  </div>
</div>
<div class="operation-box">
  <div class="col-md-12">
    <div class="row d-flex align-items-center">
      <div class="col-md-2">
        <div class="text-start">
          <button (click)="onBackButonClick()" class="btn btn-default">
            Back
          </button>
        </div>
      </div>
      <div class="col-md-6">
      </div>
<!--                    disable: !this.socialPlatformVisibility['linkedin'] }">-->
<!--                    disable: !this.socialPlatformVisibility['whatsapp'] }">-->
<!--                    disable: !this.socialPlatformVisibility['email'] }">-->
<!--                    disable: !this.socialPlatformVisibility['facebook'] }">-->
<!--                    disable: !this.socialPlatformVisibility['instagram'] }">-->
<!--                    disable: !this.socialPlatformVisibility['sms'] }">-->
<!--                    disable: !this.socialPlatformVisibility['facebook_messenger'] }">-->
<!--                    disable: !this.socialPlatformVisibility['twitter'] }">-->
<!--                    disable: !this.socialPlatformVisibility['microsoft_teams'] }">-->
<!--                    disable: !this.socialPlatformVisibility['slack'] }">-->
<!--                    disable: !this.socialPlatformVisibility['bluesky'] }">-->
<!--                    disable: !this.socialPlatformVisibility['zalo'] }">-->
<!--                    disable: !this.socialPlatformVisibility['line'] }">-->
<!--                    disable: !this.socialPlatformVisibility['wechat'] }">-->
<!--                    disable: !this.socialPlatformVisibility['telegram'] }">-->
<!--                    disable: !this.socialPlatformVisibility['vk'] }">-->
<!--                    disable: !this.socialPlatformVisibility['viber'] }">-->
      <div class="col-md-4">
        <div class="text-end">
          <button [disabled]="loader$ | async"
                  class="btn btn-default me-2" (click)="previewSocialShare()"
                  type="button">
            <span>@if (loader$ | async) {
<i class="fa fa-spinner fa-spin me-2"
                    ></i>
}Preview</span>
          </button>


          @if (campaign?.has_generic_share && campaignMeta['public_widget_enabled']) {
          <button [disabled]="loader$ | async"
                  class="btn btn-default me-2" (click)="previewGenericSocialShare()"
                  type="button">
            <span>@if (loader$ | async) {
<i class="fa fa-spinner fa-spin me-2"
                    ></i>
}Generic Share Preview</span>
          </button>
          }

          <button [disabled]="loader$ | async" (click)="onNextButtonClick()" class="btn btn-primary">
            <span>@if (loader$ | async) {
<i class="fa fa-spinner fa-spin me-2"></i>
}Next</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
